import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, OnDestroy, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, DoCheck } from '@angular/core';
import { ListColumn } from '../list-column.model';
import { DatePipe } from '@angular/common';
import { debounceTime, distinctUntilChanged, takeUntil, filter, take } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormControl, FormControl, UntypedFormGroup, FormArray } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { UsersService } from 'src/app/services/users.service';
import { Subject } from 'rxjs';
import { PaymentTypeService } from 'src/app/services/payment-type.service';
import { PoswarehouseService } from 'src/app/services/poswarehouse.service';
import { PosSupplierService } from 'src/app/services/pos-supplier.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { DealsStageService } from 'src/app/services/deals-stage.service';
import { Constant } from 'src/app/constant/constant';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { UsercallreportService } from 'src/app/services/usercallreport.service';

import { TrackerService } from 'src/app/services/tracker.service';
import { TaskStatusService } from 'src/app/services/task-status.service';
import { PriorityService } from 'src/app/services/priority.service';
import { IndustryTypeService } from 'src/app/services/industry-type.service';
import { BussinessTypeService } from 'src/app/services/bussiness-type.service';
import { CategoriesService } from 'src/app/services/categories.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'calsoft-filter-list-popup',
  templateUrl: './filter-list-popup.component.html',
  styleUrls: ['./filter-list-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FilterListPopupComponent implements OnInit, OnDestroy, DoCheck {

  url = '';
  stepUrl = '';
  stepRouter: Router;


  selectedValuesDate: { [key: string]: any } = {};

  @Input() filterSelectObj = [];

  @Input() name: string;

  @Input() progress: any;

  @Input() leadFilterType: any = 1;

  @Input() sirType = false;
  @Input() hideOthers = false;

  @Input() filterSelectObjPrevious = [];


  leadFilterType1: any = 0;

  @Input() type: any = 1;
  @Input() ChartType: any = 0;
  @Input() displayFilerOption: any = false;
  @Input() columns: ListColumn[];
  @ViewChild('filter', { static: true }) filter: ElementRef;
  @Output() filterChange = new EventEmitter<string>();
  value = new UntypedFormControl('');
  @Input() searchRequired;


  @Input() refreshRequired = false;

  @Input() displayColumnRequired: any;


  @Output() filterChangeColumn = new EventEmitter<any>();


  @Output() filterChangeColumnNew = new EventEmitter<any>();
  firstValue: any = null;
  secondValue: any = null;
  thirdValue: any = null;
  fourthValue: any = null;
  searchTerm: string = undefined;
  selected = 'ALL';
  searchValues: any;
  index: any;
  j: any;
  searchTermPresent: any = true;
  searchTermMain: any;
  searchTermMainEmit: any = 0;
  searchTermEmit: any = 0;
  searchTermMainPresent: any = true;
  rangeEnable: boolean = false;
  filterOpen: boolean = true;
  isPopupOpen: boolean;
  popupType: number;
  crmSettingsData: any;
  configData: any;
  displayOwner: boolean;
  hoursList = Array.from({ length: 12 }, (_, i) => i + 1);
  minutesList = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
  ampmList = ['AM', 'PM'];

  timeValues: { [key: number]: { hh: string, mm: string, ampm: string } } = {};

  // Per-filter search controls used by ngx-mat-select-search (one control per ngFor index)
  filterSearchControls: UntypedFormControl[] = [];
  userDropDownType: any = 1;

  onTimeChange(index: number, filter: any) {
    const time = this.timeValues[index];
    if (time && time.hh && time.mm && time.ampm) {
      filter.modelValue = `${time.hh}:${time.mm} ${time.ampm}`;
      this.filterColumnText({ target: { value: filter.modelValue } }, index, filter.modelValue);
    }
  }

  private destroy$ = new Subject<void>();

  // --- duplicate-call guard flags ---
  private _leadStatusLoaded = false;
  private _leadSourceLoaded = false;
  private _activityTypeLoaded = false;
  private _usersLoaded = false;
  private _callStatusLoaded = false;
  private _paymentLoaded = false;
  private _supplierLoaded = false;
  private _warehouseLoaded = false;
  private _dealStageLoaded = false;
  private _tagsLoaded = false;
  private _trackerLoaded = false;
  private _taskStatusLoaded = false;
  private _priorityLoaded = false;
  private _industryLoaded = false;
  private _businessLoaded = false;
  private _countryLoaded = false;
  countryTypeList: any[] = [];
  filteredcountryTypeList: any[] = [];

  // Category
  private _categoryLoaded = false;
  categoryList: any[] = [];
  categoryTypeList: any[] = [];
  filteredCategoryTypeList: any[] = [];
  masterCategoryList: any[] = [];
  categoryFilterControl: UntypedFormControl = new UntypedFormControl();

  // Product
  private _productLoaded = false;
  productList: any[] = [];
  productTypeList: any[] = [];
  filteredProductList: any[] = [];
  masterProductList: any[] = [];
  productFilterControl: UntypedFormControl = new UntypedFormControl();

  constructor(public datepipe: DatePipe,
    private poswarehouseService: PoswarehouseService,
    private _formBuilder: UntypedFormBuilder,
    private ecryptService: EcryptServiceService,
    private leadStatusService: LeadStatusService,
    private leadSourceService: LeadSourceService,
    private router: Router,
    private usersService: UsersService,
    private paymentTypeService: PaymentTypeService,
    private posSupplierService: PosSupplierService,
    private dealsStageService: DealsStageService,
    private tagesStatusService: TagesStatusService,
    private usercallreportService: UsercallreportService,
    private cdr: ChangeDetectorRef,
    private trackerService: TrackerService,
    private taskStatusService: TaskStatusService,
    private priorityService: PriorityService,
    private industryTypeService: IndustryTypeService,
    private bussinessTypeService: BussinessTypeService,
    private commonService: CommonService,
    private categoriesService: CategoriesService,
    private productService: ProductService,
  ) {
    this.url = this.router.url || '';
    this.stepRouter = this.router;
    this.stepUrl = this.url;
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; this.stepUrl = this.url; });
  }

  ngDoCheck(): void {
    this.cdr.markForCheck();
  }

  findMatchingColumn(filter: any): any {
    if (!this.columns || !Array.isArray(this.columns) || !this.columns.length || !filter) {
      return null;
    }

    const filterProp = (filter.property || '').toString().trim();
    const filterName = (filter.name || '').toString().trim();

    // 1. Direct property match (case-insensitive)
    if (filterProp) {
      const col = this.columns.find(c => c && c.property && c.property.toLowerCase() === filterProp.toLowerCase());
      if (col) return col;
    }

    // 2. Direct name match (case-insensitive)
    if (filterName) {
      const col = this.columns.find(c => c && c.name && c.name.trim().toLowerCase() === filterName.toLowerCase());
      if (col) return col;
    }

    // Helper: normalize by removing prefixes (a., b.), suffixes (_cust, _configurableProduct, etc.) and non-alphanumerics
    const normalize = (val: string) => {
      if (!val) return '';
      return val.toString().trim().toLowerCase()
        .replace(/^[a-z]\./g, '')
        .replace(/_cust$/i, '')
        .replace(/_configurableproduct$/i, '')
        .replace(/_custom$/i, '')
        .replace(/[^a-z0-9]/g, '');
    };

    const normFilterProp = normalize(filterProp);
    const normFilterName = normalize(filterName);

    // 3. Match normalized property or name
    const col = this.columns.find(c => {
      if (!c) return false;
      const normColProp = normalize(c.property);
      const normColName = normalize(c.name);

      if (normFilterProp && (normColProp === normFilterProp || normColName === normFilterProp)) {
        return true;
      }
      if (normFilterName && (normColName === normFilterName || normColProp === normFilterName)) {
        return true;
      }
      return false;
    });
    if (col) return col;

    // 4. Common CRM domain aliases
    const aliasGroups = [
      ['status', 'statusname', 'leadstatus'],
      ['source', 'sourcename', 'leadsource'],
      ['owner', 'owneremail', 'dealsowner', 'createdby', 'username', 'leadowner'],
      ['stage', 'stagename', 'dealstage', 'lifestage', 'leadstage'],
      ['country', 'countryname', 'countrycust'],
      ['city', 'cityname', 'citycust'],
      ['state', 'statename', 'statecust'],
      ['createddate', 'createdat', 'creationdate'],
      ['updateddate', 'updatedat', 'modificationdate'],
      ['activitytype', 'leadactivity'],
      ['activitycount', 'activitycountonlead'],
      ['totalcallduration', 'calldurations', 'callduration'],
      ['crno', 'crnocust'],
      ['crname', 'crnamecust'],
      ['adgroupname', 'campaignname', 'adgroupnameconfigurableproduct']
    ];

    const searchKeys = [normFilterProp, normFilterName].filter(Boolean);
    for (const key of searchKeys) {
      const group = aliasGroups.find(g => g.includes(key));
      if (group) {
        const found = this.columns.find(c => {
          if (!c) return false;
          const cp = normalize(c.property);
          const cn = normalize(c.name);
          return group.includes(cp) || group.includes(cn);
        });
        if (found) return found;
      }
    }

    return null;
  }

  isFilterFieldVisible(filter: any, index?: number): boolean {
    if (!this.columns || !Array.isArray(this.columns) || !this.columns.length) {
      return true;
    }
    const matchedCol = this.findMatchingColumn(filter);
    if (matchedCol) {
      return matchedCol.visible !== false && matchedCol.visible !== 0 && matchedCol.visible !== 'false' && matchedCol.visible !== '0';
    }
    return true;
  }

  range: UntypedFormGroup;
  init: boolean = false;
  ngOnInit() {

    let filter: any;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);

        let localType = localStorage.getItem("userDropDownType");
        if (localType != null) {
          this.userDropDownType = Number(localType);
        } else if (this.crmSettingsData.userDropDownType == undefined
          || this.crmSettingsData.userDropDownType == null
          || this.crmSettingsData.userDropDownType === "") {
          this.userDropDownType = 1;
        } else {
          this.userDropDownType = this.crmSettingsData.userDropDownType;
        }
      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }


    // this.getAllUserCallStatusList();
    // this.getAllUserCallStatus();


    let val = parseInt(localStorage.getItem(Constant.SU))

    let userType: any = localStorage.getItem(Constant.Sup);

    if (isNaN(val)) {
      val = 0;
    }

    if (val > 0 || userType === 'Sales User') {

      this.displayOwner = true;

    } else {
      this.displayOwner = false;
    }

    if (this.displayOwner) {

      let index = this.filterSelectObj.findIndex(x => x.property == 'ownerEmail');

      if (index > 0) {
        this.filterSelectObj.splice(index, 1);
      } else {

      }

    }
    if (this.router.url.includes('googleCalender')) {
      this.displayOwner = true;
    }

    if (this.displayOwner) {

      let indexForleadUserOwner = this.filterSelectObj.findIndex(x => x.property == 'ownerEmail' || x.property == 'dealsOwner')
      if (indexForleadUserOwner > -1) {
        this.getUserDropDownList();
      }

      indexForleadUserOwner = this.filterSelectObj.findIndex(x => x.property == 'a.owner_id')
      if (indexForleadUserOwner > -1) {
        this.getUserDropDownList();
      }


      if (indexForleadUserOwner < 0) {
        let indexForleadUserOwnerNew = this.filterSelectObj.findIndex(x => x.name == 'Owner' || x.name == 'User Name' || x.name == 'Created By')
        if (indexForleadUserOwnerNew > -1) {
          this.getUserDropDownList();
        }
      }
    }

    let indexForUserName = this.filterSelectObj.findIndex(x => x.property == 'u.user_name' || x.property == 'a.user_name' || x.property == 'userName')
    if (indexForUserName > -1) {
      this.getUserDropDownList();
    }

    let indexForCountry = this.filterSelectObj.findIndex(x =>
      (x.property || '').toString().toLowerCase().includes('country') ||
      (x.name || '').toString().toLowerCase().includes('country')
    );
    if (indexForCountry > -1) {
      this.getAllCountry();
    }

    let indexForCategory = this.filterSelectObj.findIndex(x => this.isCategoryFilter(x));
    if (indexForCategory > -1) {
      this.getCategoryList();
      this.CategoryYFilter();
    }

    let indexForProduct = this.filterSelectObj.findIndex(x => this.isProductFilter(x));
    if (indexForProduct > -1) {
      this.getProductList();
      this.ProductYFilter();
    }



    const encryptedConfig = localStorage.getItem('configSettingsData');
    if (encryptedConfig) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
        if (decrypted) {
          this.configData = JSON.parse(decrypted);
          // console.log("Config Settings Data:", this.configData);
          this.leadFilterType1 = this.configData.filterType;
          if (this.leadFilterType1 == 7) {
            this.type = 2;
          } else if (this.leadFilterType1 == 6) {
            this.type = 1;
          }
        }
      } catch (err) {
        console.error("Error decrypting configSettingsData", err);
      }
    }


    let url = this.router.url;
    this.initializeForm();

    if (filter != undefined) {


      if (this.leadFilterType1 == 4 || this.leadFilterType1 == 7) {
        this.filterOpen = false
      }
    }


    let cleanUrl = url.split('?')[0];
    let range: any = JSON.parse(localStorage.getItem(cleanUrl + "range"))
    let filterObject = [];
    const stored = localStorage.getItem(cleanUrl + 'selectedDate');
    if (stored) {
      try {
        this.selectedValuesDate = JSON.parse(stored) || {};
      } catch (e) {
        console.error('Error parsing stored data', e);
        this.selectedValuesDate = {};
      }
    }



    filterObject = JSON.parse(localStorage.getItem(cleanUrl))
    let searchTerm = localStorage.getItem(cleanUrl + "se")
    let type = localStorage.getItem(cleanUrl + "type")
    if (filterObject == null) {
      filterObject = [];
    } else {
      if (Array.isArray(this.filterSelectObj) && this.filterSelectObj.length > 0 && Array.isArray(filterObject)) {
        filterObject.forEach((cachedItem: any, idx: number) => {
          const inputItem = this.filterSelectObj.find((f: any) => f && f.property === cachedItem.property) || this.filterSelectObj[idx];
          if (inputItem && inputItem.type) {
            cachedItem.type = inputItem.type;
          }
          if (inputItem && inputItem.options && inputItem.options.length > 0) {
            cachedItem.options = inputItem.options;
          }
        });
      }
      this.filterSelectObj = filterObject;
      this.addDateRangeFormGroup();
    }


    if (type == "2" && this.filterSelectObj.length > 0 && searchTerm != null) {
      this.addDateRangeFormGroup();
      let selected: any = null;
      try {
        selected = JSON.parse(localStorage.getItem(cleanUrl + "selected"));
      } catch (e) {
        // ignore JSON parse errors; we'll try to handle as string below
        selected = localStorage.getItem(cleanUrl + "selected");
      }

      if (selected != null) {
        this.selectedValues = selected;
      }

      // Support legacy storage key 'select' which may contain a stringified object
      const rawSelect = localStorage.getItem(cleanUrl + 'select');
      if (rawSelect) {
        const parseFallback = (raw: string) => {
          // try JSON
          try {
            return JSON.parse(raw);
          } catch (_e) {
            const map: any = {};
            const regex = /([\w\.\- ]+)\s*[:=]\s*(\[[^\]]*\]|"[^"]*"|'[^']*'|[^,;]+)/g;
            let m: RegExpExecArray | null;
            while ((m = regex.exec(raw)) !== null) {
              const key = m[1].trim();
              let val = m[2].trim();
              if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
                val = val.slice(1, -1);
              }
              if (val.startsWith('[') && val.endsWith(']')) {
                const inner = val.slice(1, -1).trim();
                map[key] = inner.length ? inner.split(/\s*,\s*/).map(v => v.replace(/^['"]|['"]$/g, '').trim()) : [];
              } else if (val.indexOf('|') !== -1) {
                map[key] = val.split('|').map((v: string) => v.trim());
              } else if (val.indexOf(',') !== -1) {
                map[key] = val.split(',').map((v: string) => v.trim());
              } else {
                map[key] = val;
              }
            }
            return map;
          }
        };

        try {
          const selectParsed = parseFallback(rawSelect);
          if (selectParsed && typeof selectParsed === 'object') {
            Object.keys(selectParsed).forEach(k => {
              const val = selectParsed[k];
              const idx = this.filterSelectObj.findIndex((f: any) => {
                if (!f) return false;
                if (f.property === k || f.name === k || f.property === k.trim()) return true;
                if (this.resolveSearchProperty(f) === k) return true;
                if (f.property && f.property.toLowerCase() === k.toLowerCase()) return true;
                if (k.endsWith('_cust') && (f.property === k.replace(/_cust$/i, '') || f.name === k.replace(/_cust$/i, ''))) return true;
                return false;
              });
              if (idx > -1) {
                const element = this.filterSelectObj[idx];
                if (element.type === 'multiSelect') {
                  const arr = Array.isArray(val) ? val : (typeof val === 'string' ? val.split(/\s*,\s*|\|/).map((v: string) => v.trim()) : []);
                  this.selectedValues[idx] = arr;
                  try { this[element.position] = arr; } catch (e) { }
                } else if (element.type === 'select') {
                  const v = Array.isArray(val) ? val[0] : val;
                  this.selectedValues[idx] = v;
                  try { this[element.position] = v; } catch (e) { }
                } else if (element.type === 'date') {
                  try { this[element.position] = val; this.selectedValuesDate[element.position] = val; } catch (e) { }
                } else {
                  element.modelValue = val;
                  try { this[element.position] = val; } catch (e) { }
                }
              }
            });
          }
        } catch (err) {
          // ignore parse errors for legacy select
        }
      }

      let indexValue = 0;

      this.filterSelectObj.forEach(element => {

        if (searchTerm == null || searchTerm == undefined || searchTerm == '') {

          element.modelValue = '';
        }


        if (filterObject[indexValue] && filterObject[indexValue].modelValue !== undefined) {
          element.modelValue = filterObject[indexValue].modelValue;
        }

        if (element.type == 'multiSelect') {
          console.log(element);

          this[element.position] = this.selectedValues[indexValue];

          console.log(this[element.position]);
        }


        if (element.type == 'date') {
          this[element.position] = this.selectedValuesDate[element.position];
        }


        indexValue++;
      });
      this.searchTerm = searchTerm;
      this.searchTermPresent = false;
      this.cdr.markForCheck();
    }

    if (type == "1" && searchTerm != null) {
      this.filter.nativeElement.value = searchTerm;

      this.refreshRequired = false;
    }

    if (searchTerm == undefined) {

      this.filterSelectObj.forEach(element => {
        element.modelValue = '';


      });


    }






    let indexForleadStatus = this.filterSelectObj.findIndex(x => x.name == 'Status Name')
    if (indexForleadStatus > -1) {
      this.getLeadDropDownList();
    } else {
      indexForleadStatus = this.filterSelectObj.findIndex(x => x.property == 'statusName')
      if (indexForleadStatus > -1) {
        this.getLeadDropDownList();
      } else {
        indexForleadStatus = this.filterSelectObj.findIndex(x => x.property == 'c.status_name' || x.name == 'Lead Status')
        if (indexForleadStatus > -1) {
          this.getLeadDropDownList();
        }
      }


    }


    let indexForDealStage = this.filterSelectObj.findIndex(x => x.name == 'Stage'
      || x.name == 'Stage Name'
      || x.property == 'stage'
      || x.name == 'Deal Stage')


    if (indexForDealStage > -1) {


      this.getDealStage();
    }


    let indexForLoacation = this.filterSelectObj.findIndex(x => x.name == 'Location' || x.name == 'Warehouse' || x.name == 'Warehouse Name' || x.property == 'warehouse' || x.property == 'warehouseName')
    if (indexForLoacation > -1) {
      this.getAllWareHouseList();
    }

    let indexForSupplier = this.filterSelectObj.findIndex(x => x.name == 'Suppliers' || x.name == 'Supplier' || x.name == 'Supplier Name' || x.property == 'supplier' || x.property == 'a.supplier')
    if (indexForSupplier > -1) {
      this.getAllSupplierList();
    }

    let indexForleadSource = this.filterSelectObj.findIndex(x => x.name == 'Source Name')
    if (indexForleadSource > -1) {
      this.getLeadSourceDownList();
    } else {
      indexForleadSource = this.filterSelectObj.findIndex(x => x.property == 'sourceName')
      if (indexForleadSource > -1) {
        this.getLeadSourceDownList();
      } else {
        indexForleadSource = this.filterSelectObj.findIndex(x => x.property == 'g.source_name' || x.name == 'Lead Source')
        if (indexForleadSource > -1) {
          this.getLeadSourceDownList();
        }
      }


    }

    let indexForleadStage = this.filterSelectObj.findIndex(x => x.name == 'Life Stage')
    if (indexForleadStage > -1) {
      this.getLeadDropDownList();
    }

    let indexForTags = this.filterSelectObj.findIndex(x => x.name == 'Tags' || x.name == 'tags' || x.property == 'tagName' || x.property == 'tagsJson')
    if (indexForTags > -1) {
      this.getAllTags();
    }


    let indexForTypeOfService = this.filterSelectObj.findIndex(x => x.name == 'Type of Service')
    if (indexForTypeOfService > -1) {
      this.getPaymentList();
    }
    let indexForleadUser = this.filterSelectObj.findIndex(x =>
      x.name == 'User Name' ||
      x.property == 'createdBy' ||
      x.property == 'created_by' ||
      x.property == 'a.created_by' ||
      x.property == 'ownerEmail' ||
      x.property == 'dealsOwner' ||
      x.property == 'a.user_name' ||
      x.property == 'u.user_name' ||
      x.property == 'userName' ||
      x.property == 'a.owner_id'
    );
    if (indexForleadUser > -1) {
      this.getUserDropDownList();
    }
    let indexForleadActivity = this.filterSelectObj.findIndex(x => x.name == 'Activity Type')
    if (indexForleadActivity > -1) {
      this.getLeadActivityTypeDownList();
    }

    // Tracker dropdown
    let indexForTracker = this.filterSelectObj.findIndex(x => x.name == 'Tracker' || x.property == 'tracker');
    if (indexForTracker > -1) {
      this.getTrackerDropDownList();
    }

    // Task Status dropdown
    let indexForTaskStatus = this.filterSelectObj.findIndex(x => x.property == 'status' && x.name != 'Status Name' && x.name != 'Lead Status' && (!x.options || x.options.length == 0) && !this.url.includes('posPurchase') && !this.url.includes('purchasesreport') && !this.url.includes('purchasesReport'));
    if (indexForTaskStatus > -1) {
      this.getTaskStatusDownList();
    }

    // Priority dropdown
    let indexForPriority = this.filterSelectObj.findIndex(x => x.name == 'Priority' || x.property == 'priority');
    if (indexForPriority > -1) {
      this.getPriorityDropDownList();
    }

    // Industry Type dropdown
    let indexForIndustry = this.filterSelectObj.findIndex(x => x.name == 'Industry Type' || x.property == 'industryType');
    if (indexForIndustry > -1) {
      this.getAllIndustry();
      this.IndustryYFilter();
    }

    // Business Type dropdown
    let indexForBusiness = this.filterSelectObj.findIndex(x => x.name == 'Busniess Type' || x.property == 'businessType');
    if (indexForBusiness > -1) {
      this.getAllBusiness();
      this.BusinessYFilter();
    }

    let indexForCategory2 = this.filterSelectObj.findIndex(x => this.isCategoryFilter(x));
    if (indexForCategory2 > -1) {
      this.getCategoryList();
      this.CategoryYFilter();
    }

    let indexForProduct2 = this.filterSelectObj.findIndex(x => this.isProductFilter(x));
    if (indexForProduct2 > -1) {
      this.getProductList();
      this.ProductYFilter();
    }

    let indexForleadUserOwner = this.filterSelectObj.findIndex(x => x.name == 'Owner' || x.name == 'Created By')
    if (indexForleadUserOwner > -1) {
      this.getUserDropDownList();
    } else {
      indexForleadUserOwner = this.filterSelectObj.findIndex(x =>
        x.property == 'ownerEmail' ||
        x.property == 'dealsOwner' ||
        x.property == 'a.created_by' ||
        x.property == 'createdBy' ||
        x.property == 'created_by' ||
        x.property == 'a.user_name' ||
        x.property == 'a.owner_id'
      );
      if (indexForleadUserOwner > -1) {
        this.getUserDropDownList();
      }


    }

    if (this.refreshRequired == undefined) {
      this.refreshRequired = false;
    }

    if (this.searchRequired == undefined) {
      this.searchRequired = true;
    }
    if (this.displayColumnRequired == undefined) {
      this.displayColumnRequired = true;
    }


    this.modelChanged
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        takeUntil(this.destroy$))
      .subscribe((event) => {

        let value = (<HTMLInputElement>this.searchValues['target']).value;
        let code = this.searchValues['code'];
        if (code == 'Space' && value == ' ') {
          value = value.trim();
        } else if (code == 'Backspace') {
          this.filterColumnText(value, this.index, this.j)
          if (this.searchTermEmit == 0 && this.searchTerm == undefined) {
            this.searchTermPresent = true;

          } else {
            this.searchTermPresent = false;
          }

        }
        else if (code != 'Space' && value.trim().length == 0) {
          value = value.trim();
        }
        else if (value.trim().length > 0) {
          this.filterColumnText(value, this.index, this.j)
        }
      })

    this.filterSelectObj.forEach((element, idx) => {
      if (element.type === 'time') {
        if (!this.timeValues[idx]) {
          this.timeValues[idx] = { hh: '', mm: '', ampm: 'AM' };
        }
        if (element.modelValue) {
          const val = element.modelValue.toUpperCase();
          if (val.includes('AM') || val.includes('PM')) {
            const parts = val.split(':');
            if (parts.length >= 2) {
              const mParts = parts[1].trim().split(' ');
              this.timeValues[idx] = {
                hh: parts[0],
                mm: mParts[0],
                ampm: mParts[1] || 'AM'
              };
            }
          }
        }
      }
    });

    this.init = true;
    // initialize per-filter search controls after setup
    this.setupSearchControls();
  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }


  filtersForm: UntypedFormGroup;
  initializeForm(): void {
    this.filtersForm = this._formBuilder.group({
      ranges: this._formBuilder.array([])
    });

    this.addDateRangeFormGroup();
  }
  addDateRangeFormGroup(): void {
    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    let range = JSON.parse(localStorage.getItem(cleanUrl + "range") || 'null');

    // Ensure filtersForm is initialized
    if (!this.filtersForm) {
      this.filtersForm = this._formBuilder.group({
        ranges: this._formBuilder.array([])
      });
    }

    const rangesArray = this.filtersForm.get('ranges') as FormArray;
    // Clear existing controls and rebuild to ensure sync with current filterSelectObj
    while (rangesArray.length !== 0) {
      rangesArray.removeAt(0);
    }

    if (!Array.isArray(this.filterSelectObj)) return;

    this.filterSelectObj.forEach((element: any, indexValue: number) => {
      let start: any = '';
      let end: any = '';

      if (range && range.ranges && range.ranges[indexValue]) {
        if (range.ranges[indexValue].start != null && range.ranges[indexValue].start !== '') {
          start = new Date(range.ranges[indexValue].start);
        }
        if (range.ranges[indexValue].end != null && range.ranges[indexValue].end !== '') {
          end = new Date(range.ranges[indexValue].end);
        }
      }

      const rangeGroup = this._formBuilder.group({
        start: start,
        end: end
      });

      rangesArray.push(rangeGroup);
    });
    this.cdr.markForCheck();
  }


  modelChanged = new Subject<string>();
  search(value, index, j) {
    this.searchValues = value;
    this.index = index;
    this.j = j;

  }



  onPaste(event: ClipboardEvent, index) {
    const filter = this.filterSelectObj && this.filterSelectObj[index];
    if (filter && (this.isNumericFilter(filter) || this.isIntegerFilter(filter))) {
      event.preventDefault();
      let pastedData = '';
      if ((window as any).clipboardData && (window as any).clipboardData.getData) {
        pastedData = (window as any).clipboardData.getData('Text');
      } else if (event.clipboardData && event.clipboardData.getData) {
        pastedData = event.clipboardData.getData('text/plain');
      }

      if (this.isIntegerFilter(filter)) {
        pastedData = (pastedData || '').replace(/[^0-9]/g, '');
      } else {
        pastedData = (pastedData || '').replace(/[^0-9.]/g, '');
        const parts = pastedData.split('.');
        if (parts.length > 2) {
          pastedData = parts[0] + '.' + parts.slice(1).join('');
        }
      }

      const target = event.target as HTMLInputElement;
      if (target) {
        const start = target.selectionStart || 0;
        const end = target.selectionEnd || 0;
        const currentVal = target.value || '';
        let combined = currentVal.substring(0, start) + pastedData + currentVal.substring(end);
        if (this.isNumericFilter(filter)) {
          const parts = combined.split('.');
          if (parts.length > 2) {
            combined = parts[0] + '.' + parts.slice(1).join('');
          }
        } else if (this.isIntegerFilter(filter)) {
          combined = combined.replace(/[^0-9]/g, '');
        }
        target.value = combined;
        filter.modelValue = combined;
        let obj = {
          target: { value: combined },
          code: 'Paste'
        };
        this.filterColumnText(obj, index, combined);
      }
      return;
    }

    // Allow the paste to finish updating the ngModel, then trigger the filter update
    setTimeout(() => {
      let val = this.filterSelectObj[index].modelValue || '';
      let obj = {
        target: { value: val },
        code: 'Paste'
      };
      this.filterColumnText(obj, index, val);
    }, 10);
  }

  // toggleColumnVisibility(column, event,index) {


  //   event.stopPropagation();
  //   event.stopImmediatePropagation();


  //   column.visible = !column.visible;
  //   this.columns[index].visible = !this.columns[index].visible; 

  //   console.log(this.columns[index].visible);


  // }

  toggleColumnVisibility(column, event, index) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
    this.columns[index].visible = !this.columns[index].visible;
  }


  setValue(index: any, checked) {
    console.log(this.columns[index].visible);

    event.stopPropagation();
    event.stopImmediatePropagation();

  }

  resetFilters() {
    this.searchTermMain = ''

    this.filtersForm.reset();
    this.filterSelectObj.forEach((value, key) => {
      // clear modelValue to undefined so other checks that test for !== undefined behave correctly
      value.modelValue = undefined;
      this[value.position] = undefined
      if (value.type === 'time') {
        this.timeValues[key] = { hh: '', mm: '', ampm: 'AM' };
      }
    })
    this.selected = 'ALL'
    this.searchTerm = null;
    this.searchTerm = undefined;
    this.searchTermPresent = true;

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");

    this.filterChangeColumn.emit(this.searchTerm)
    this.selectedValues = [];
    this.filteredCategoryTypeList = this.categoryTypeList ? [...this.categoryTypeList] : [];
    this.filteredProductList = this.productList ? [...this.productList] : [];
    this.filterOpen = false;
    this.cdr.markForCheck();
    this.callclosepopup();
  }

  @Input() rangeactive: any = 0;
  @Input() updatedDateRange: number;
  @Input() updatedIndex: number;

  previousDateRange: number;  // Store the previous value of updatedDateRange


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['updatedDateRange'] || changes['updatedIndex']) {
      console.log('Updated Date Range:', this.updatedDateRange);
      console.log('Updated Index:', this.updatedIndex);
    }
    // Check if the 'updatedDateRange' has changed
    if (changes['updatedDateRange'] && changes['updatedDateRange'].currentValue !== this.previousDateRange) {
      // Update the previousDateRange to the new value
      this.previousDateRange = changes['updatedDateRange'].currentValue;

      // Call the function only if the value has actually changed
      this.onRangeSelected(this.updatedDateRange, 1);
    }

    if (changes['filterSelectObj']) {

      console.log("herew");


      this.filterSelectObj = changes['filterSelectObj'].currentValue


      if (this.filterSelectObj.length > 0) {

        let indexForleadStatus = this.filterSelectObj.findIndex(x => x.property == 'statusName')
        if (indexForleadStatus > -1) {
          this.getLeadDropDownList();
        }



        let indexForleadSource = this.filterSelectObj.findIndex(x => x.property == 'sourceName')
        if (indexForleadSource > -1) {
          this.getLeadSourceDownList();
        }

        let indexForTypeOfService = this.filterSelectObj.findIndex(x => x.name == 'Type of Service')
        if (indexForTypeOfService > -1) {
          this.getPaymentList();
        }

        let indexForleadUser = this.filterSelectObj.findIndex(x => x.name == 'User Name')
        if (indexForleadUser > -1) {
          this.getUserDropDownList();
        }
        let indexForleadActivity = this.filterSelectObj.findIndex(x => x.name == 'Activity Type')
        if (indexForleadActivity > -1) {
          this.getLeadActivityTypeDownList();
        }

        let indexForleadUserOwner = this.filterSelectObj.findIndex(x => x.property == 'ownerEmail' || x.property == 'dealsOwner')
        if (indexForleadUserOwner > -1) {
          this.getUserDropDownList();
        }

        let indexForCountry = this.filterSelectObj.findIndex(x =>
          (x.property || '').toString().toLowerCase().includes('country') ||
          (x.name || '').toString().toLowerCase().includes('country')
        );
        if (indexForCountry > -1) {
          this.getAllCountry();
        }

        let indexForCategory = this.filterSelectObj.findIndex(x => this.isCategoryFilter(x));
        if (indexForCategory > -1) {
          this.getCategoryList();
          this.CategoryYFilter();
        }

        let indexForProduct = this.filterSelectObj.findIndex(x => this.isProductFilter(x));
        if (indexForProduct > -1) {
          this.getProductList();
          this.ProductYFilter();
        }
        this.ensureCategoryAndProductTypes();

        this.cdr.markForCheck();
        // recreate/ensure search controls for new filters
        this.setupSearchControls();
        this.addDateRangeFormGroup();
      }




    }




  }

  /**
   * Create per-filter FormControls and subscribe to valueChanges to filter option arrays.
   */
  setupSearchControls(): void {
    if (!Array.isArray(this.filterSelectObj)) return;
    this.filterSearchControls = this.filterSearchControls || [];

    this.filterSelectObj.forEach((filter: any, idx: number) => {
      // Always (re-)initialize inline options on every call so ngOnChanges replacements are handled
      if (filter.options && Array.isArray(filter.options)) {
        const deduped = this.dedupeOptions(JSON.parse(JSON.stringify(filter.options)));
        filter._originalOptions = deduped;
        filter._filteredOptions = [...deduped];
      }

      if (!this.filterSearchControls[idx]) {
        this.filterSearchControls[idx] = new UntypedFormControl('');
        this.filterSearchControls[idx].valueChanges
          .pipe(debounceTime(200), distinctUntilChanged(), takeUntil(this.destroy$))
          .subscribe((val: any) => {
            // Always resolve the CURRENT filter object at this index (avoids stale closure reference)
            const f = this.filterSelectObj[idx];
            if (!f) return;
            const q = (val || '').toString().trim().toLowerCase();
            const match = (item: any, keys: string[]) => {
              if (!item) return false;
              for (const k of keys) {
                const v = item[k];
                if (v && v.toString().toLowerCase().includes(q)) return true;
              }
              return false;
            };

            if (!q) {
              // restore original lists when query cleared
              if (f.property === 'tagName') this.filteredtagsTypeList = this.tagsTypeList ? [...this.tagsTypeList] : [];
              else if ((f.property || '').toString().toLowerCase().includes('source')) this.filteredLeadSourceTypeList = this.LeadSourceTypeList ? [...this.LeadSourceTypeList] : [];
              else if (f.property === 'statusName' || (f.name || '').toString().toLowerCase().includes('status name') || (f.name || '').toString().toLowerCase().includes('life stage') || (f.name || '').toString().toLowerCase().includes('lead status')) this.filtereddropdownTypeList = this.dropdownTypeList ? [...this.dropdownTypeList] : [];
              else if ((f.property === 'a.status') || ((f.name || '').toString().toLowerCase() === 'status')) {
                if (this.taskStatusTypeList) this.filteredTaskStatusTypeList = [...this.taskStatusTypeList];
                if (this.UserCallStatusTypeList) this.filteredUserCallStatusTypeList = [...this.UserCallStatusTypeList];
              }
              else if (((f.property || '').toString().toLowerCase().includes('stage')) || ((f.name || '').toString().toLowerCase().includes('stage'))) this.filteredlDealStatusTypeList = this.dealStatusTypeList ? [...this.dealStatusTypeList] : [];
              else if (((f.property || '').toString().toLowerCase().includes('owner')) || ((f.property || '').toString().toLowerCase().includes('user_name')) || ((f.property || '').toString().toLowerCase().includes('user_id')) || ((f.property || '').toString().toLowerCase().includes('created')) || ((f.name || '').toString().toLowerCase().includes('owner')) || ((f.name || '').toString().toLowerCase().includes('created by')) || ((f.name || '').toString().toLowerCase().includes('user name'))) {
                this.filtereduserTypeList = this.userTypeList ? [...this.userTypeList] : [];
                this.filtereduserSolrTypeList = this.userTypeSolrList ? [...this.userTypeSolrList] : [];
              }
              else if ((f.name || '').toString().toLowerCase().includes('type of service')) this.filteredPayemntTypeList = this.paymentTypeList ? [...this.paymentTypeList] : [];
              else if ((f.name || '').toString().toLowerCase().includes('activity')) this.filteredActivityTypeList = this.LeadActivityTypeList ? [...this.LeadActivityTypeList] : [];
              else if (((f.property || '').toString().toLowerCase().includes('industry'))) this.filteredindustryTypeList = this.industryTypeList ? [...this.industryTypeList] : [];
              else if (((f.property || '').toString().toLowerCase().includes('business'))) this.filteredBusinessTypeList = this.BusinessTypeList ? [...this.BusinessTypeList] : [];
              else if (((f.property || '').toString().toLowerCase().includes('supplier')) || ((f.name || '').toString().toLowerCase().includes('suppliers'))) {
                this.filteredsupplierTypeList = this.supplierTypeList ? [...this.supplierTypeList] : [];
                if (f.options && Array.isArray(f.options)) {
                  f._filteredOptions = [...f.options];
                }
              }
              else if (((f.property || '').toString().toLowerCase().includes('warehouse')) || ((f.name || '').toString().toLowerCase().includes('location')) || ((f.name || '').toString().toLowerCase().includes('warehouse'))) this.filteredWarehouseTypeList = this.warehouseTypeList ? [...this.warehouseTypeList] : [];
              else if (((f.property || '').toString().toLowerCase().includes('tracker')) || ((f.name || '').toString().toLowerCase().includes('tracker'))) this.filteredTrackerTypeList = this.trackerTypeList ? [...this.trackerTypeList] : [];
              else if (((f.property || '').toString().toLowerCase().includes('priority')) || ((f.name || '').toString().toLowerCase().includes('priority'))) this.filteredPriorityTypeList = this.priorityTypeList ? [...this.priorityTypeList] : [];
              else if (((f.property || '').toString().toLowerCase().includes('country')) || ((f.name || '').toString().toLowerCase().includes('country'))) this.filteredcountryTypeList = this.countryTypeList ? [...this.countryTypeList] : [];
              else if (this.isCategoryFilter(f)) this.filteredCategoryTypeList = this.categoryTypeList ? [...this.categoryTypeList] : [];
              else if (this.isProductFilter(f)) {
                const source = (this.masterProductList && this.masterProductList.length > 0) ? this.masterProductList : (this.productList || []);
                this.filteredProductList = [...source];
              }
              // Restore inline options from the current filter's preserved original
              if (f.options && Array.isArray(f.options)) {
                const deduped = this.dedupeOptions(JSON.parse(JSON.stringify(f.options)));
                f._originalOptions = deduped;
                f._filteredOptions = [...deduped];
              }
              this.cdr.markForCheck();
              return;
            }

            // apply filter when q exists
            if (f.property === 'tagName') this.filteredtagsTypeList = (this.tagsTypeList || []).filter(item => match(item, ['statusName', 'status', 'name', 'viewValue', 'value']));
            else if ((f.property || '').toString().toLowerCase().includes('source')) this.filteredLeadSourceTypeList = (this.LeadSourceTypeList || []).filter(item => match(item, ['sourceName', 'name', 'viewValue', 'value']));
            else if (f.property === 'statusName' || (f.name || '').toString().toLowerCase().includes('status name') || (f.name || '').toString().toLowerCase().includes('life stage') || (f.name || '').toString().toLowerCase().includes('lead status')) this.filtereddropdownTypeList = (this.dropdownTypeList || []).filter(item => match(item, ['statusName', 'status', 'name', 'viewValue', 'value']));
            else if ((f.property === 'a.status') || ((f.name || '').toString().toLowerCase() === 'status')) {
              if (this.taskStatusTypeList && this.taskStatusTypeList.length) this.filteredTaskStatusTypeList = (this.taskStatusTypeList || []).filter(item => match(item, ['statusName', 'status', 'name', 'viewValue', 'value']));
              if (this.UserCallStatusTypeList && this.UserCallStatusTypeList.length) this.filteredUserCallStatusTypeList = (this.UserCallStatusTypeList || []).filter(item => match(item, ['Status', 'status', 'name', 'viewValue', 'value']));
              if (!(this.taskStatusTypeList && this.taskStatusTypeList.length) && !(this.UserCallStatusTypeList && this.UserCallStatusTypeList.length) && f.options) {
                f._originalOptions = JSON.parse(JSON.stringify(f.options));
                f._filteredOptions = (f._originalOptions || []).filter(o => (o.viewValue || o.value || '').toString().toLowerCase().includes(q));
              }
            }
            else if (((f.property || '').toString().toLowerCase().includes('stage')) || ((f.name || '').toString().toLowerCase().includes('stage'))) this.filteredlDealStatusTypeList = (this.dealStatusTypeList || []).filter(item => match(item, ['statusName', 'status', 'name', 'viewValue', 'value']));
            else if (((f.property || '').toString().toLowerCase().includes('owner')) || ((f.property || '').toString().toLowerCase().includes('user_name')) || ((f.property || '').toString().toLowerCase().includes('user_id')) || ((f.property || '').toString().toLowerCase().includes('created')) || ((f.name || '').toString().toLowerCase().includes('owner')) || ((f.name || '').toString().toLowerCase().includes('created by')) || ((f.name || '').toString().toLowerCase().includes('user name'))) {
              this.filtereduserTypeList = (this.userTypeList || []).filter(item => match(item, ['email', 'name', 'fullName', 'userName', 'user_name', 'u.user_name', 'a.user_name', 'viewValue', 'value']));
              this.filtereduserSolrTypeList = (this.userTypeSolrList || []).filter(item => match(item, ['email', 'originalEmail', 'firstName', 'name', 'userName', 'user_name', 'viewValue', 'value']));
            }
            else if ((f.name || '').toString().toLowerCase().includes('type of service')) this.filteredPayemntTypeList = (this.paymentTypeList || []).filter(item => match(item, ['name', 'displayName', 'viewValue', 'value']));
            else if ((f.name || '').toString().toLowerCase().includes('activity')) this.filteredActivityTypeList = (this.LeadActivityTypeList || []).filter(item => match(item, ['activityType', 'name', 'viewValue', 'value']));
            else if (((f.property || '').toString().toLowerCase().includes('industry'))) this.filteredindustryTypeList = (this.industryTypeList || []).filter(item => match(item, ['statusName', 'name', 'viewValue', 'value']));
            else if (((f.property || '').toString().toLowerCase().includes('business'))) this.filteredBusinessTypeList = (this.BusinessTypeList || []).filter(item => match(item, ['statusName', 'name', 'viewValue', 'value']));
            else if (((f.property || '').toString().toLowerCase().includes('supplier')) || ((f.name || '').toString().toLowerCase().includes('suppliers'))) {
              this.filteredsupplierTypeList = (this.supplierTypeList || []).filter(item => match(item, ['name', 'displayName', 'viewValue', 'value']));
              if (f.options && Array.isArray(f.options)) {
                f._filteredOptions = (f.options || []).filter(item => match(item, ['name', 'displayName', 'viewValue', 'value']));
              }
            }
            else if (((f.property || '').toString().toLowerCase().includes('warehouse')) || ((f.name || '').toString().toLowerCase().includes('location')) || ((f.name || '').toString().toLowerCase().includes('warehouse'))) this.filteredWarehouseTypeList = (this.warehouseTypeList || []).filter(item => match(item, ['name', 'displayName', 'viewValue', 'value']));
            else if (((f.property || '').toString().toLowerCase().includes('tracker')) || ((f.name || '').toString().toLowerCase().includes('tracker'))) this.filteredTrackerTypeList = (this.trackerTypeList || []).filter(item => match(item, ['name', 'trackerName', 'viewValue', 'value']));
            else if (((f.property || '').toString().toLowerCase().includes('country')) || ((f.name || '').toString().toLowerCase().includes('country'))) this.filteredcountryTypeList = (this.countryTypeList || []).filter(item => match(item, ['countryName', 'name', 'viewValue', 'value']));
            else if ((f.name || '').toString().toLowerCase().includes('priority')) this.filteredPriorityTypeList = (this.priorityTypeList || []).filter(item => match(item, ['statusName', 'name', 'viewValue', 'value']));
            else if (this.isCategoryFilter(f)) this.filteredCategoryTypeList = (this.categoryTypeList || []).filter(item => match(item, ['name', 'categoryName', 'id', 'categoryId', 'viewValue', 'value']));
            else if (this.isProductFilter(f)) {
              const source = (this.masterProductList && this.masterProductList.length > 0) ? this.masterProductList : (this.productList || []);
              this.filteredProductList = source.filter(item => match(item, ['name', 'code', 'id', 'productId', 'viewValue', 'value']));
              this.fetchProducts(q);
            }

            // Always update inline options filtered view from _originalOptions (not filter.options directly)
            if (f.options) {
              f._originalOptions = JSON.parse(JSON.stringify(f.options));
              f._filteredOptions = (f._originalOptions || []).filter(o => (o.viewValue || o.value || '').toString().toLowerCase().includes(q));
            }

            this.cdr.markForCheck();
          });
      }
    });
  }




  dateRangeOptions = [
    { label: 'Last 10 Days', value: 10 },
    { label: 'Last 20 Days', value: 20 },
    { label: 'Last 30 Days', value: 30 },
  ];
  selectedRange = this.dateRangeOptions[0].value;

  onRangeSelected(days: number, index: number): void {
    if (!this.filtersForm) {
      this.initializeForm();
    }
    const currentDate = new Date();
    const startDate = new Date();
    startDate.setDate(currentDate.getDate() - days);

    // Format dates using the existing datepipe
    const formattedStart = this.datepipe.transform(startDate, 'yyyy-MM-dd');
    const formattedEnd = this.datepipe.transform(currentDate, 'yyyy-MM-dd');

    // Update the filtersForm values
    const ranges = this.filtersForm?.get('ranges') as FormArray;
    if (ranges && ranges.at && ranges.length > index && ranges.at(index)) {
      ranges.at(index).patchValue({
        start: formattedStart,
        end: formattedEnd,
      });
    }

    // Reuse the existing logic
    if (this.filterSelectObj && this.filterSelectObj[index]) {
      this.start({ value: formattedStart }, 'start', index);
      this.end({ value: formattedEnd }, 'end', index);
      this.searchFilter();
    }
  }


  resetFiltersMobiletest() {
    this.searchTermMain = ''

    this.filtersForm.reset();
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
      this[value.position] = undefined
      if (value.type === 'time') {
        this.timeValues[key] = { hh: '', mm: '', ampm: 'AM' };
      }
    })
    this.selected = 'ALL'
    this.searchTerm = null;
    this.searchTerm = undefined;
    this.searchTermPresent = true;

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");

    this.filterChangeColumn.emit(this.searchTerm)
    this.selectedValues = [];
    this.filteredCategoryTypeList = this.categoryTypeList ? [...this.categoryTypeList] : [];
    this.filteredProductList = this.productList ? [...this.productList] : [];
  }


  filterColumnText(value, index, j) {
    let finalValue = (<HTMLInputElement>value['target']).value;
    const filter = this.filterSelectObj && this.filterSelectObj[index];
    if (filter) {
      if (this.isIntegerFilter(filter)) {
        const cleaned = (finalValue || '').replace(/[^0-9]/g, '');
        if (cleaned !== finalValue) {
          finalValue = cleaned;
          if (value['target']) {
            (<HTMLInputElement>value['target']).value = finalValue;
          }
          filter.modelValue = finalValue;
        }
      } else if (this.isNumericFilter(filter)) {
        let cleaned = (finalValue || '').replace(/[^0-9.]/g, '');
        const parts = cleaned.split('.');
        if (parts.length > 2) {
          cleaned = parts[0] + '.' + parts.slice(1).join('');
        }
        if (cleaned !== finalValue) {
          finalValue = cleaned;
          if (value['target']) {
            (<HTMLInputElement>value['target']).value = finalValue;
          }
          filter.modelValue = finalValue;
        }
      }
    }
    if (finalValue && finalValue.trim().length > 0) {
      this.searchValues = value;
      this[this.filterSelectObj[index].position] = finalValue;
    } else {
      this[this.filterSelectObj[index].position] = undefined;
    }
    this.filterOutput();
    this.cdr.markForCheck();
  }

  filterColumn(value, index, j) {
    let finalValue = value.value;

    if (this[this.filterSelectObj[index].position] == null) {
      this[this.filterSelectObj[index].position] = finalValue;
    } else {
      if (finalValue == undefined && finalValue != 'ALL') {
        this[this.filterSelectObj[index].position] = finalValue;
      }
      else if (j.length == 0) {
        this[this.filterSelectObj[index].position] = undefined;
      }
      else if (this.filterSelectObj[index].type == 'select') {
        if (finalValue != 'ALL') {
          this[this.filterSelectObj[index].position] = finalValue;
        }
        else {
          this[this.filterSelectObj[index].position] = undefined;
        }
      }
      else if (this.filterSelectObj[index].type == 'multiSelect') {
        // handled by filterColumnMultiSelect
      }
      else {
        this[this.filterSelectObj[index].position] = undefined;
      }
    }

    if (this.filterSelectObj && this.filterSelectObj[index] && this.isCategoryFilter(this.filterSelectObj[index])) {
      this.fetchProducts();
    }

    this.filterOutput();
    this.cdr.markForCheck();
  }

  selectedValues: any[] = [];
  filterColumnMultiSelect(value, index, j) {
    const rawValues = Array.isArray(value?.value) ? value.value : (value?.value ? [value.value] : []);
    this.selectedValues[index] = rawValues;

    if (rawValues.length > 0) {
      this[this.filterSelectObj[index].position] = rawValues.join(',');
    } else {
      this[this.filterSelectObj[index].position] = undefined;
    }

    if (this.filterSelectObj && this.filterSelectObj[index] && this.isCategoryFilter(this.filterSelectObj[index])) {
      this.fetchProducts();
    }

    this.filterOutput();
    this.cdr.markForCheck();
  }


  filterOutput() {

    this.searchTerm = undefined;

    const isMeaningful = (val: any): boolean => {
      if (val === undefined || val === null) {
        return false;
      }
      if (Array.isArray(val)) {
        return val.some(item => {
          if (item === undefined || item === null) return false;
          const s = typeof item === 'string' ? item : String(item);
          return s.replace(/\*/g, '').trim().length > 0;
        });
      }

      const s = String(val).trim().toLowerCase();

      if (s === 'all') return false;

      if (s.replace(/\*/g, '').length === 0) return false;

      return true;


    };

    this.filterSelectObj.forEach((element, indexForLoop) => {
      const prop = this.resolveSearchProperty(this.filterSelectObj[indexForLoop]);
      const type = this.filterSelectObj[indexForLoop].type;
      const val = this[element['position']];

      if (!isMeaningful(val)) {
        return;
      }

      let clause = '';
      if (type == 'price' || type == 'number' || this.isNumericFilter(this.filterSelectObj[indexForLoop])) {
        clause = `${prop}:${val}`;
      } else if (type == 'date') {
        const dateVal = String(val).includes('~') ? val : `${val}~${val}`;
        clause = `${prop}:*${dateVal}*`;
      } else if (type == 'time') {
        let val12 = this.convertTo12Hour(val);
        clause = `${prop}:'*${val12}*'`;
      } else if (type == 'multiSelect' || type == 'multiselect') {
        let items: string[] = [];
        if (Array.isArray(val)) {
          items = val.map(v => String(v).trim()).filter(v => v.length > 0);
        } else if (typeof val === 'string' && val.trim().length > 0) {
          items = val.split(',').map(v => v.trim()).filter(v => v.length > 0);
        }
        const isIdFilter = this.isProductFilter(this.filterSelectObj[indexForLoop]) ||
          this.isCategoryFilter(this.filterSelectObj[indexForLoop]) ||
          (items.length > 0 && items.every(it => /^\d+$/.test(it)));

        if (items.length === 1) {
          if (isIdFilter) {
            clause = `${prop}:${items[0]}`;
          } else {
            clause = `${prop}:*${items[0].toLowerCase()}*`;
          }
        } else if (items.length > 1) {
          if (isIdFilter) {
            const itemClauses = items.map(v => `${prop}:${v}`);
            clause = `(${itemClauses.join(' OR ')})`;
          } else {
            const itemClauses = items.map(v => `${prop}:*${v.toLowerCase()}*`);
            clause = `(${itemClauses.join(' OR ')})`;
          }
        }
      } else if (type != 'select') {
        const lowerVal = String(val).toLowerCase();
        clause = `${prop}:'*${lowerVal}*'`;
      }
      else {
        if (prop === 'c.quantity' || prop === 'quantity' || prop === 'b.quantity' || prop === 'item_nane' || prop === 'FSI.item_name') {
          clause = `${prop}:'*${val}*'`;
        } else if (typeof val === 'string' && (val.includes(' ') || /[&+#:()<>\/\\!~]/.test(val))) {
          clause = `${prop}:'${val}'`;
        } else {
          clause = `${prop}:${val}`;
        }
      }



      if (this.searchTerm == undefined) {
        this.searchTerm = clause;
      } else {
        this.searchTerm = this.searchTerm + ' AND ' + clause;
      }
    });

    if (this.searchTerm == undefined) {
      this.searchTermPresent = true;
    } else {
      this.searchTermPresent = false;
    }

  }

  start(event, type, index) {
    let startDate = this.datepipe.transform(event.value, 'yyyy-MM-dd');

    this[this.filterSelectObj[index].position] = startDate ? `${startDate}~${startDate}` : '';
    this.selectedValuesDate[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position];
    this.filterOutput();
    console.log(this.filtersForm);

  }


  end(event, type, index) {

    let endDate = this.datepipe.transform(event.value, 'yyyy-MM-dd');


    if (this.filtersForm.value.ranges && this.filtersForm.value.ranges[index] != null && endDate != null) {
      // Find the index of the first tilde
      const tildeIndex = this[this.filterSelectObj[index].position] ? this[this.filterSelectObj[index].position].indexOf('~') : -1;

      // If a tilde is found, replace everything after it
      this[this.filterSelectObj[index].position] = tildeIndex === -1
        ? this[this.filterSelectObj[index].position]
        : this[this.filterSelectObj[index].position].substring(0, tildeIndex + 1);
      this[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position] ? this[this.filterSelectObj[index].position].replace(/~/g, '') : '';
      this[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position] + '~' + endDate;
      this.selectedValuesDate[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position];
      this.filterOutput();
    }
    console.log(this.filtersForm);

  }

  clearDateRange(index: number, event: Event) {
    if (event) {
      event.stopPropagation();
    }

    // Clear the form group values
    const ranges = this.filtersForm.get('ranges') as FormArray;
    if (ranges && ranges.at(index)) {
      ranges.at(index).patchValue({
        start: null,
        end: null
      });
    }

    // Clear backend stored properties
    this[this.filterSelectObj[index].position] = undefined;
    this.filterSelectObj[index].modelValue = undefined;
    this.selectedValuesDate[this.filterSelectObj[index].position] = undefined;
    if (this.selectedValues) {
      this.selectedValues[index] = undefined;
    }

    this.filterOutput();
    this.cdr.markForCheck();
  }

  hasDateValue(index: number): boolean {
    const ranges = this.filtersForm.get('ranges') as FormArray;
    if (!ranges || !ranges.at(index)) return false;
    const group = ranges.at(index);
    return !!(group?.get('start')?.value || group?.get('end')?.value);
  }



  searchFilter() {

    const ranges = this.filtersForm?.get('ranges') as FormArray;
    if (ranges) {
      this.filterSelectObj.forEach((element, index) => {
        if (element.type === 'date') {
          const group = ranges.at(index);
          const startVal = group?.get('start')?.value;
          const endVal = group?.get('end')?.value;
          if (startVal) {
            const startStr = this.datepipe.transform(startVal, 'yyyy-MM-dd');
            const endStr = endVal ? this.datepipe.transform(endVal, 'yyyy-MM-dd') : startStr;
            this[element.position] = `${startStr}~${endStr}`;
            this.selectedValuesDate[element.position] = this[element.position];
          }
        }
      });
    }
    this.filterOutput();

    if (this.searchTerm == undefined) {
      this.searchTermPresent = true;
      this.searchTermEmit = 0;
    } else {
      this.searchTermPresent = false;
      this.searchTermEmit++;
    }

    var rule = /\s{1,}/g;

    if (this.searchTerm != undefined) {
      this.searchTerm = this.searchTerm.split(rule).join(" ");
    }

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];

    localStorage.removeItem(cleanUrl);
    localStorage.setItem(cleanUrl, JSON.stringify(this.filterSelectObj));

    if (this.searchTerm === undefined || this.searchTerm === null) {
      localStorage.removeItem(cleanUrl + "se");
    } else {
      localStorage.setItem(cleanUrl + "se", this.searchTerm);
    }
    localStorage.setItem(cleanUrl + "type", "2");

    localStorage.setItem(cleanUrl + "range", JSON.stringify(this.filtersForm.value));

    localStorage.setItem(cleanUrl + "selected", JSON.stringify(this.selectedValues));
    localStorage.setItem(cleanUrl + "selectedDate", JSON.stringify(this.selectedValuesDate));

    // Also write a `select` object for legacy/alternate consumers. Build an object mapping filter property/name -> value
    try {
      const selectObj: any = {};
      this.filterSelectObj.forEach((f: any, idx: number) => {
        const key = f.property || f.name || (`field_${idx}`);
        // prefer explicit stored position values, then modelValue, then selectedValues array
        let val: any = undefined;
        try { val = this[f.position]; } catch (e) { val = undefined; }
        if (val === undefined || val === null || val === '') {
          if (f.modelValue !== undefined && f.modelValue !== '') {
            val = f.modelValue;
          } else if (Array.isArray(this.selectedValues) && this.selectedValues[idx] !== undefined) {
            val = this.selectedValues[idx];
          }
        }
        if (val !== undefined) {
          selectObj[key] = val;
        }
      });
      if (Object.keys(selectObj).length === 0) {
        localStorage.removeItem(cleanUrl + 'select');
      } else {
        localStorage.setItem(cleanUrl + 'select', JSON.stringify(selectObj));
      }
    } catch (err) {
      // ignore storage errors
    }

    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");

    this.closePopup.emit(true);
    this.filterChangeColumn.emit(this.searchTerm);
  }


  searchFilterMain() {

    if (!this.searchTermMainPresent) {
      if (!this.searchTermMain || this.searchTermMain.trim().length == 0) {
        this.searchTermMainPresent = true;
        this.searchTermMainEmit = 0;
      } else {
        this.searchTermMainPresent = false;
        this.searchTermMainEmit++;
        const rule = /\s{1,}/g;
        if (this.searchTermMain != undefined) {
          this.searchTermMain = this.searchTermMain.split(rule).join(' ');
        }

        const url = this.router.url;
        const cleanUrl = url.split('?')[0];

        localStorage.removeItem(cleanUrl);
        localStorage.setItem(cleanUrl, JSON.stringify(this.filterSelectObj));
        localStorage.setItem(cleanUrl + 'se', this.searchTermMain);
        localStorage.setItem(cleanUrl + 'type', '1');
        localStorage.setItem(cleanUrl + 'range', JSON.stringify(this.filtersForm.value));
        localStorage.setItem(cleanUrl + 'selected', JSON.stringify(this.selectedValues));
        localStorage.setItem(cleanUrl + 'selectedDate', JSON.stringify(this.selectedValuesDate));

        // Also write a `select` object for legacy/alternate consumers.
        try {
          const selectObj: any = {};
          this.filterSelectObj.forEach((f: any, idx: number) => {
            const key = f.property || f.name || (`field_${idx}`);
            let val: any = undefined;
            try { val = this[f.position]; } catch (e) { val = undefined; }
            if (val === undefined || val === null || val === '') {
              if (f.modelValue !== undefined && f.modelValue !== '') {
                val = f.modelValue;
              } else if (Array.isArray(this.selectedValues) && this.selectedValues[idx] !== undefined) {
                val = this.selectedValues[idx];
              }
            }
            if (val !== undefined) selectObj[key] = val;
          });
          localStorage.setItem(cleanUrl + 'select', JSON.stringify(selectObj));
        } catch (err) {
          // ignore storage errors
        }

        localStorage.removeItem('advanceFilterConditionsText');
        localStorage.removeItem('advanceFilterEnble');
        localStorage.removeItem('advanceFilterConditions');
      }

      this.filterChange.emit(this.searchTermMain);

    } else {
      this.searchTermMainEmit = 0;
      this.searchTermMainPresent = true;
    }
  }

  mobileSearch() {
    let value = this.value.value;


    this.searchTermMain = value;
    this.searchTermMainPresent = false;

    this.searchFilterMain()

  }

  resetFiltersMobile() {

    this.value.reset();
    this.filter.nativeElement.value = '';
    this.resetFiltersMobiletest()
    this.selectedValues = [];
  }

  createRangeForm() {
    this.range = this._formBuilder.group({
      start: [''],
      end: [''],



    },


    )
  }


  //lead status

  filtereddropdownTypeList: any;

  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();

  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;


  getLeadDropDownList() {
    if (this._leadStatusLoaded) return;
    this._leadStatusLoaded = true;
    this.leadStatusService.getAllLeadStatusDropDown(0)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          const normalized = this.normalizeByKey(res, 'statusName', ['status', 'name', 'Status']);
          this.dropdownList = normalized;
          this.dropdownTypeList = this.dedupeByKey(normalized, 'statusName');
          this.filtereddropdownTypeList = this.dropdownTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();

        },
        error => {
        })
  }



  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(user => user['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  //leadSource

  filteredLeadSourceTypeList: any;

  LeadSourceTypeList: any;
  LeadSourceList: any;

  getLeadSourceDownList() {
    if (this._leadSourceLoaded) return;
    this._leadSourceLoaded = true;
    this.leadSourceService.getAllLeadSourceDropDown()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          const normalized = this.normalizeByKey(res, 'sourceName', ['name', 'source', 'source_name']);
          this.LeadSourceList = normalized;
          this.LeadSourceTypeList = this.dedupeByKey(normalized, 'sourceId');
          this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
        })
  }


  LeadSourceYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadSourceYFilter();
      });
  }


  protected typeLeadSourceYFilter() {
    if (!this.LeadSourceTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredLeadSourceTypeList = this.LeadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList.filter(source => source['sourceName'].toLowerCase().indexOf(search) > -1)
  }

  getAllSourcedropdowntype() {
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
  }

  //ActivityType

  filteredActivityTypeList: any;

  LeadActivityTypeList: any;
  LeadActivityList: any;

  getLeadActivityTypeDownList() {
    if (this._activityTypeLoaded) return;
    this._activityTypeLoaded = true;
    this.leadSourceService.getAllActivityTypeDropDown()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          const normalized = this.normalizeByKey(res, 'activityType', ['name', 'type']);
          this.LeadActivityList = normalized;
          this.LeadActivityTypeList = this.dedupeByKey(normalized, 'activityType');
          this.filteredActivityTypeList = this.LeadActivityTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
        })
  }


  LeadActivityTypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadActivityTypeYFilter();
      });
  }


  protected typeLeadActivityTypeYFilter() {
    if (!this.LeadActivityTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredActivityTypeList = this.LeadActivityTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredActivityTypeList = this.LeadActivityTypeList.filter(source => source['activityType'].toLowerCase().indexOf(search) > -1)
  }

  getAllActivityTypedropdowntype() {
    this.filteredActivityTypeList = this.LeadActivityTypeList;
  }




  //user Group

  defaultLeadOwner: FormControl = new FormControl('');

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  userTypeSolrList: any;
  userSolrList: any;
  filtereduserSolrTypeList: any;
  public typeSolrYFilterControl: UntypedFormControl = new UntypedFormControl();

  getUserDropDownList() {
    if (this._usersLoaded) return;
    this._usersLoaded = true;

    let val: any = localStorage.getItem('userType')

    if (val == null) {
      val = 0;
    } else if (val == 'salesUser') {
      val = 1;
    } else {
      val = 0;
    }

    console.log(val);

    let value = localStorage.getItem("userDropDownType");

    if (value != null) {
      this.userDropDownType = Number(value);
    } else {
      this.userDropDownType = 1;
    }

    if (this.userDropDownType == 0) {
      this.usersService.getAllUserListSolr()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res: any) => {
            let data = res;
            if (res && !Array.isArray(res)) {
              data = res.data || res.response || res.content || [];
            }
            if (!Array.isArray(data)) {
              data = [];
            }

            const normalized = data.map((item: any) => ({
              ...item,
              email: item.firstName ? `${item.firstName} (${item.email})` : item.email,
              originalEmail: item.email // Keep original email just in case
            }));
            const normalizedResult = this.normalizeByKey(normalized, 'email', ['userName', 'user_name', 'name']);
            this.userSolrList = normalizedResult;
            this.userTypeSolrList = this.dedupeUsers(normalizedResult);
            this.filtereduserSolrTypeList = this.userTypeSolrList;
            this.cdr.markForCheck();
            this.reapplySearchControls();
          },
          error => {
          })
    } else if (!this.router.url.includes('crmAnalytics') && val == 0) {

      this.usersService.getAllUserStatusDropDown()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          res => {
            const list = Array.isArray(res) ? res : ((res as any)?.data || (res as any)?.response || (res as any)?.content || []);
            const normalized = this.normalizeByKey(list, 'email', ['userName', 'user_name', 'name']);
            this.userList = normalized;
            this.userTypeList = this.dedupeUsers(normalized);
            this.filtereduserTypeList = this.userTypeList;
            this.cdr.markForCheck();
            this.reapplySearchControls();
          },
          error => {
          })
    } else {
      this.usersService.getAllUserStatusDropDownSales()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          res => {
            const list = Array.isArray(res) ? res : ((res as any)?.data || (res as any)?.response || (res as any)?.content || []);
            const normalized = this.normalizeByKey(list, 'email', ['userName', 'user_name', 'name']);
            this.userList = normalized;
            this.userTypeList = this.dedupeUsers(normalized);
            this.filtereduserTypeList = this.userTypeList;
            this.cdr.markForCheck();
            this.reapplySearchControls();
          },
          error => {
          })
    }

  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  usertypeSolrYFilter() {
    this.typeSolrYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeSolridYFilter();
      });
  }

  protected usertypeSolridYFilter() {
    if (!this.userTypeSolrList) {
      return;
    }
    let search = this.typeSolrYFilterControl.value;
    if (!search) {
      this.filtereduserSolrTypeList = this.userTypeSolrList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtereduserSolrTypeList = this.userTypeSolrList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  close() {
    this.filterOpen = false;
  }

  openNew() {
    this.filterOpen = true;
  }


  openNew1() {
    this.isPopupOpen = true;
  }





  handleFilterApplied(event: any) {

    console.log("search", event);
    this.filterChangeColumn.emit(event)

  }

  handleFilterReset(event) {
    console.log('Filters reset');

    this.filterChangeColumn.emit(this.searchTerm)

  }
  @Output() closePopup = new EventEmitter();
  callclosepopup() {
    this.closePopup.emit(true)
  }


  // User call status lists and controls
  UserCallStatusList: any = [];
  UserCallStatusTypeList: any = [];
  filteredUserCallStatusTypeList: any = [];
  userCallStatusControl: UntypedFormControl = new UntypedFormControl();
  userCallStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllUserCallStatusList() {
    if (this._callStatusLoaded) return;
    this._callStatusLoaded = true;
    this.userCallStatusYFilter();
    this.getAllUserCallStatus();
    this.usercallreportService.getAllUserStatusDropDown()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          const raw: any[] = Array.isArray(data) ? data : [];

          const normalized = raw.map((item: any) => {
            if (typeof item === 'string') return { Status: item };
            if (!item || typeof item !== 'object') return { Status: String(item) };
            if (item.Status) return { Status: item.Status };
            if (item.status) return { Status: item.status };
            if (item.statusName) return { Status: item.statusName };
            const first = Object.values(item).find(v => typeof v === 'string');
            return { Status: first ? String(first) : JSON.stringify(item) };
          });

          this.UserCallStatusList = this.dedupeByKey(normalized, 'Status');
          this.UserCallStatusTypeList = this.UserCallStatusList;
          this.filteredUserCallStatusTypeList = this.UserCallStatusTypeList;
          try { console.debug('UserCallStatus normalized:', this.filteredUserCallStatusTypeList); } catch (e) { }
          const statusFilter = this.filterSelectObj && this.filterSelectObj.find ? this.filterSelectObj.find(f => f.property === 'a.status' || f.name === 'Status') : null;
          if (statusFilter) {
            statusFilter.options = this.filteredUserCallStatusTypeList.map((s: any) => ({ value: s.Status, viewValue: s.Status }));
            try { console.debug('Status filter.options set:', statusFilter.options); } catch (e) { }
          }
          // reapply any active search text now that data has loaded
          this.reapplySearchControls();
        },
        error => {
        }
      );
  }

  private dedupeUsers(items: any[]): any[] {
    if (!Array.isArray(items)) return [];
    const seen = new Set<string>();
    const out: any[] = [];
    for (const item of items) {
      let raw = '';
      if (item && typeof item === 'object') {
        raw = item.userName || item.user_name || item.name || item.fullName || item.email || item.value || item.viewValue || '';
      } else if (item != null) {
        raw = String(item);
      }
      const normalized = String(raw).trim().toLowerCase();
      if (!normalized || seen.has(normalized)) continue;
      seen.add(normalized);
      out.push(item);
    }
    return out;
  }

  private dedupeByKey(items: any[], key: string): any[] {
    if (!Array.isArray(items)) return [];
    const seen = new Set<string>();
    const out: any[] = [];
    for (const item of items) {
      const raw = item && item[key] !== undefined && item[key] !== null ? String(item[key]) : '';
      const normalized = raw.trim().toLowerCase();
      if (!normalized || seen.has(normalized)) continue;
      seen.add(normalized);
      out.push(item);
    }
    return out;
  }

  private normalizeByKey(items: any, key: string, fallbackKeys: string[] = []): any[] {
    if (!Array.isArray(items)) return [];
    return items.map((item: any) => {
      if (item && typeof item === 'object') {
        if (item[key] !== undefined && item[key] !== null) return item;
        for (const k of fallbackKeys) {
          if (item[k] !== undefined && item[k] !== null) {
            return { ...item, [key]: item[k] };
          }
        }
        const first = Object.values(item).find(v => typeof v === 'string' && v.trim().length > 0);
        return first ? { ...item, [key]: first } : item;
      }
      return { [key]: String(item) };
    });
  }

  private dedupeOptions(options: any[]): any[] {
    if (!Array.isArray(options)) return [];
    const seen = new Set<string>();
    const out: any[] = [];
    for (const opt of options) {
      let raw: any = '';
      if (opt && typeof opt === 'object') {
        raw = opt.value ?? opt.viewValue ?? opt.name ?? opt.statusName ?? opt.sourceName ?? opt.email ?? opt.activityType ?? opt.trackerName ?? opt.id;
      } else {
        raw = opt;
      }
      const normalized = raw !== undefined && raw !== null ? String(raw).trim().toLowerCase() : '';
      if (!normalized || seen.has(normalized)) continue;
      seen.add(normalized);
      out.push(opt);
    }
    return out;
  }

  getAllUserCallStatus() {
    this.filteredUserCallStatusTypeList = this.UserCallStatusTypeList;
  }

  userCallStatusYFilter() {
    this.userCallStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.UserCallStatusFilter();
      });
  }

  protected UserCallStatusFilter() {
    if (!this.UserCallStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.userCallStatusFilterControl.value;
    if (!search) {
      this.filteredUserCallStatusTypeList = this.UserCallStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredUserCallStatusTypeList = this.UserCallStatusTypeList.filter(supplier => supplier['Status'].toLowerCase().indexOf(search) > -1)
  }


  //paidBy

  paymentList: any;
  paymentTypeList: any;
  filteredPayemntTypeList: any;

  public paymentFilterControl: UntypedFormControl = new UntypedFormControl();

  getPaymentList() {
    if (this._paymentLoaded) return;
    this._paymentLoaded = true;
    this.paymentTypeService.getAllPaymentModeDropDown()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          const normalized = this.normalizeByKey(res, 'name', ['displayName', 'value']);
          this.paymentList = normalized;
          this.paymentTypeList = this.dedupeByKey(normalized, 'name');
          this.filteredPayemntTypeList = this.paymentTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();

        },
        () => {
        })
  }


  PaymentYFilter() {
    this.paymentFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.paymentFilter();
      });
  }


  protected paymentFilter() {
    if (!this.paymentTypeList) {
      return;
    }
    // get the search keyword
    let search = this.paymentFilterControl.value;
    if (!search) {
      this.filteredPayemntTypeList = this.paymentTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredPayemntTypeList = this.paymentTypeList.filter(bank => bank['name']
      .toLowerCase().indexOf(search) > -1)
  }

  getAllPaymentSet() {
    this.filteredPayemntTypeList = this.paymentTypeList;
  }

  //supplier
  supplierList: any = [];
  supplierTypeList: any = [];
  filteredsupplierTypeList: any = [];
  supplierControl: UntypedFormControl = new UntypedFormControl();
  supplierFilterControl: UntypedFormControl = new UntypedFormControl();
  options: any;


  getAllSupplierList() {
    if (this._supplierLoaded) return;
    this._supplierLoaded = true;
    this.supplierYFilter();
    this.getAllsupplier();
    this.posSupplierService.getAllsupplierDropDown()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          const normalized = this.normalizeByKey(data, 'name', ['supplierName']);
          this.supplierList = normalized;

          this.supplierTypeList = this.dedupeByKey(normalized, 'name');
          this.filteredsupplierTypeList = this.supplierTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();

        }
      )
  }

  getAllsupplier() {
    this.filteredsupplierTypeList = this.supplierTypeList;
  }

  supplierYFilter() {
    this.supplierFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.supplierFilter();
      });
  }

  protected supplierFilter() {
    if (!this.supplierTypeList) {
      return;
    }
    // get the search keyword
    let search = this.supplierFilterControl.value;
    if (!search) {
      this.filteredsupplierTypeList = this.supplierTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredsupplierTypeList = this.supplierTypeList.filter(supplier => supplier['name'].toLowerCase().indexOf(search) > -1)
  }

  //warehouse
  warehouseList: any = [];
  warehouseTypeList: any = [];
  filteredWarehouseTypeList: any = [];
  warehouseControl: UntypedFormControl = new UntypedFormControl();
  warehouseFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllWareHouseList() {
    if (this._warehouseLoaded) return;
    this._warehouseLoaded = true;
    this.warehouseYFilter();
    this.getAllWarehouse();
    this.poswarehouseService.getAllWarehouseDropDown()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          const normalized = this.normalizeByKey(data, 'name', ['warehouseName', 'location']);
          this.warehouseList = normalized;


          // this.warehouseList.push(object);

          this.warehouseTypeList = this.dedupeByKey(normalized, 'name');
          this.filteredWarehouseTypeList = this.warehouseTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();

        }
      )
  }


  getAllWarehouse() {
    this.filteredWarehouseTypeList = this.warehouseTypeList;
  }

  warehouseYFilter() {
    this.warehouseFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.warehouseFilter();
      });
  }

  protected warehouseFilter() {
    if (!this.warehouseTypeList) {
      return;
    }
    // get the search keyword
    let search = this.warehouseFilterControl.value;
    if (!search) {
      this.filteredWarehouseTypeList = this.warehouseTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredWarehouseTypeList = this.warehouseTypeList.filter(Warehouse => Warehouse['name'].toLowerCase().indexOf(search) > -1)
  }

  //stagr


  getDealStage() {
    if (this._dealStageLoaded) return;
    this._dealStageLoaded = true;
    this.LeadStatusYFilter();
    this.getLeadStatusList();
    this.dealsStageService.getAllDealsStagesDropDown(4)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          const normalized = this.normalizeByKey(res, 'statusName', ['name', 'status']);
          this.dealStatusList = normalized;
          this.dealStatusTypeList = this.dedupeByKey(normalized, 'statusName');
          this.filteredlDealStatusTypeList = this.dealStatusTypeList;

          console.log(this.dealStatusList);
          this.cdr.markForCheck();


        },
        error => {
        }
      )
  }

  //lead status

  dealStatusList: any;
  dealStatusTypeList: any;
  filteredlDealStatusTypeList: any;

  public dealStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadStatusList() {

    this.filteredlDealStatusTypeList = this.dealStatusTypeList;
  }

  LeadStatusYFilter() {
    this.dealStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.dealStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.dealStatusFilterControl.value;
    if (!search) {
      this.filteredlDealStatusTypeList = this.dealStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredlDealStatusTypeList = this.dealStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }

  //Tags

  tagsList: any = [];
  tagsTypeList: any = [];
  filteredtagsTypeList: any = [];
  tagsControl: UntypedFormControl = new UntypedFormControl();
  tagsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTags() {
    if (this._tagsLoaded) return;
    this._tagsLoaded = true;
    const isSequencesPage = (this.url && this.url.includes('sequences')) || (this.router.url && this.router.url.includes('sequences'));
    const tagsObs = isSequencesPage
      ? this.tagesStatusService.getAllTagsDropDownSequence(10)
      : this.tagesStatusService.getAllTagsDropDown(5);

    tagsObs
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          const normalized = this.normalizeByKey(data, 'statusName', ['name', 'tagName']);
          this.tagsList = normalized;
          this.tagsTypeList = this.dedupeByKey(normalized, 'statusName');
          this.filteredtagsTypeList = this.tagsTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
        }
      )
  }

  TagsYFilter() {
    this.tagsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagsFilter();
      });
  }

  protected tagsFilter() {
    if (!this.tagsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.tagsFilterControl.value;
    if (!search) {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredtagsTypeList = this.tagsTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
  }

  // Tracker
  trackerList: any = [];
  trackerTypeList: any = [];
  filteredTrackerTypeList: any = [];

  getTrackerDropDownList() {
    if (this._trackerLoaded) return;
    this._trackerLoaded = true;
    this.trackerService.getAllTrackerDropDownCache()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          const normalized = this.normalizeByKey(res, 'trackerName', ['name']);
          this.trackerList = normalized;
          this.trackerTypeList = this.dedupeByKey(normalized, 'trackerName');
          this.filteredTrackerTypeList = this.trackerTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
        }
      );
  }


  // Task Status
  taskStatusList: any = [];
  taskStatusTypeList: any = [];
  filteredTaskStatusTypeList: any = [];

  getTaskStatusDownList() {
    if (this._taskStatusLoaded) return;
    this._taskStatusLoaded = true;
    this.taskStatusService.getAlltaskStatusDropDown(0)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          const normalized = this.normalizeByKey(res, 'statusName', ['name', 'status', 'Status']);
          this.taskStatusList = normalized;
          this.taskStatusTypeList = this.dedupeByKey(normalized, 'statusName');
          this.filteredTaskStatusTypeList = this.taskStatusTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
        }
      );
  }

  // Priority
  priorityList: any = [];
  priorityTypeList: any = [];
  filteredPriorityTypeList: any = [];

  getPriorityDropDownList() {
    if (this._priorityLoaded) return;
    this._priorityLoaded = true;
    this.priorityService.getAllPriorityDropDownCache()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          const normalized = this.normalizeByKey(res, 'statusName', ['priorityName', 'name', 'priority', 'value']);
          this.priorityList = normalized;
          this.priorityTypeList = this.dedupeByKey(normalized, 'statusName');
          this.filteredPriorityTypeList = this.priorityTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
        }
      );
  }

  // Industry Type
  industryList: any = [];
  industryTypeList: any = [];
  filteredindustryTypeList: any = [];
  industryFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllIndustry() {
    if (this._industryLoaded) return;
    this._industryLoaded = true;
    this.industryTypeService.getAllIndustryTypeDropDown(6)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          const normalized = this.normalizeByKey(data, 'statusName', ['name', 'industryType']);
          this.industryList = normalized;
          this.industryTypeList = this.dedupeByKey(normalized, 'statusName');
          this.filteredindustryTypeList = this.industryTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
        }
      )
  }

  IndustryYFilter() {
    this.industryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.industryFilter();
      });
  }

  protected industryFilter() {
    if (!this.industryTypeList) {
      return;
    }
    let search = this.industryFilterControl.value;
    if (!search) {
      this.filteredindustryTypeList = this.industryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredindustryTypeList = this.industryTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
    this.cdr.markForCheck();
  }

  // Business Type
  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];
  BusinessFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllBusiness() {
    if (this._businessLoaded) return;
    this._businessLoaded = true;
    this.bussinessTypeService.getAllBusinessDropDown(7)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          const normalized = this.normalizeByKey(data, 'statusName', ['name', 'businessType']);
          this.BusinessList = normalized;
          this.BusinessTypeList = this.dedupeByKey(normalized, 'statusName');
          this.filteredBusinessTypeList = this.BusinessTypeList;
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
        }
      )
  }

  BusinessYFilter() {
    this.BusinessFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.BusinessFilter();
      });
  }

  protected BusinessFilter() {
    if (!this.BusinessTypeList) {
      return;
    }
    let search = this.BusinessFilterControl.value;
    if (!search) {
      this.filteredBusinessTypeList = this.BusinessTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBusinessTypeList = this.BusinessTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
    this.cdr.markForCheck();
  }

  blockColon(event: KeyboardEvent) {
    if (event.key === ':') {
      event.preventDefault();
    }
  }

  /**
   * Returns true only when a filter should render its own inline `filter.options` list.
   * All filters that have a dedicated dynamic API list return false so the catch-all
   * ng-container in the template does NOT double-render those options.
   */
  shouldUseInlineOptions(filter: any): boolean {
    if (!filter) return false;
    const p = (filter.property || '').toLowerCase();
    const n = (filter.name || '').toLowerCase();
    // filters that have a dedicated dynamic container in template
    if (this.isCategoryFilter(filter)) return false;
    if (this.isProductFilter(filter)) return false;
    if (p.includes('warehouse') || n.includes('warehouse') || n === 'location') return false;
    if (p.includes('supplier') || n.includes('supplier')) return false;
    if (p === 'tagname' || p === 'tagsjson' || n === 'tags') return false;
    if (p === 'country' || n === 'country' || p === 'customvaluesiscountry' || p === 'country_cust') return false;
    if (p === 'isactive' || p === 'is_active' || p.includes('active')) return true;
    if (p === 'a.status' || p === 'status' || (n === 'status' && (!filter.options || filter.options.length === 0))) return false;
    if (n === 'owner' || n === 'created by' || n === 'updated by' || n === 'user name' || n === 'email' || p === 'a.owner' || p === 'a.owner_id' || p === 'owneremail' || p === 'dealsowner' || p === 'createdby' || p === 'created_by' || p === 'a.created_by' || p === 'a.user_name' || p === 'u.user_name' || p === 'username') return false;
    if (p === 'statusname' || p === 'c.status_name' || n === 'status name' || n === 'life stage' || n === 'lead status') return false;
    if (p === 'sourcename' || p === 'g.source_name' || n === 'source name' || n === 'lead source') return false;
    if (p === 'stage' || p === 'a.stage' || p === 'b.statusname' || p === 'b.status_name' || n === 'deal stage' || n === 'stage' || n === 'stage name') return false;
    if (n === 'type of service') return false;
    if (n === 'activity type') return false;
    if (p === 'tracker' || n === 'tracker') return false;
    if (p === 'priority' || n === 'priority') return false;
    if (p === 'industrytype' || n === 'industry type') return false;
    if (p === 'businesstype' || n === 'business type' || n === 'busniess type') return false;

    if (this.url && (this.url.includes('whatsAppBotFlows') || this.url.includes('leadMeetingSummaryReport') || this.url.includes('botRepliesList') || this.url.includes('expenseCategories') || this.url.includes('posPurchase') || this.url.includes('holidays') || this.url.includes('upcomingAccountRenewal') || this.url.includes('purchasesreport') || this.url.includes('purchasesReport') || this.url.includes('supplierreport') || this.url.includes('supplier_report'))) return true;

    if (filter.options && filter.options.length > 0) return true;
    return false;
  }

  showSearchForFilter(filter: any): boolean {
    if (!filter) return false;
    const name = (filter.name || '').toString().toLowerCase().trim();
    const prop = (filter.property || '').toString().toLowerCase().trim();

    // Do not show search box for binary or short status/active fields
    if (name === 'is active' || name === 'active' || name === 'active status' || prop === 'isactive' || prop === 'is_active') {
      return false;
    }

    // Always show search for product and category filters
    if (this.isCategoryFilter(filter) || this.isProductFilter(filter)) {
      return true;
    }

    // Do not show search box if filter has a small fixed list of options (<= 4)
    if (filter._originalOptions && Array.isArray(filter._originalOptions) && filter._originalOptions.length <= 4) {
      return false;
    }
    if (filter.options && Array.isArray(filter.options) && filter.options.length <= 4) {
      return false;
    }

    return true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this._onDestroy.next();
    this._onDestroy.complete();
    // reset load guards so data re-fetches if component is recreated
    this._leadStatusLoaded = false;
    this._leadSourceLoaded = false;
    this._activityTypeLoaded = false;
    this._usersLoaded = false;
    this._callStatusLoaded = false;
    this._paymentLoaded = false;
    this._supplierLoaded = false;
    this._warehouseLoaded = false;
    this._dealStageLoaded = false;
    this._tagsLoaded = false;
    this._trackerLoaded = false;
    this._taskStatusLoaded = false;
    this._priorityLoaded = false;
    this._industryLoaded = false;
    this._businessLoaded = false;
    this._countryLoaded = false;
    this._categoryLoaded = false;
    this._productLoaded = false;
  }

  getAllCountry() {
    if (this._countryLoaded) return;
    this._countryLoaded = true;
    this.commonService.getCountryList()
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          this.countryTypeList = Array.isArray(res) ? res : [];
          this.filteredcountryTypeList = [...this.countryTypeList];

          if (Array.isArray(this.filterSelectObj)) {
            this.filterSelectObj.forEach((f: any) => {
              const prop = (f.property || '').toString().toLowerCase();
              const name = (f.name || '').toString().toLowerCase();
              if (prop.includes('country') || name.includes('country')) {
                if (f.type === 'text' || !f.type) {
                  f.type = 'select';
                }
                f.options = this.countryTypeList;
                f._originalOptions = [...this.countryTypeList];
                f._filteredOptions = [...this.countryTypeList];
              }
            });
          }
          this.cdr.markForCheck();
        },
        error => {
          this._countryLoaded = false;
        }
      );
  }

  isCategoryFilter(filter: any): boolean {
    if (!filter) return false;
    const name = (filter.name || '').toString().toLowerCase().trim();
    const prop = (filter.property || '').toString().toLowerCase().trim();
    return name.includes('category') || prop.includes('category');
  }

  isProductFilter(filter: any): boolean {
    if (!filter) return false;
    if (this.isCategoryFilter(filter)) return false;
    const name = (filter.name || '').toString().toLowerCase().trim();
    const prop = (filter.property || '').toString().toLowerCase().trim();
    return name.includes('product') || prop.includes('product');
  }

  resolveSearchProperty(filter: any): string {
    if (!filter) return '';
    const rawProp = (filter.property || '').toString().trim();
    const rawName = (filter.name || '').toString().trim();

    // 0. Date, time, price, number filters or explicit date range properties must NEVER have _cust appended
    if (filter.type === 'date' || filter.type === 'time' || filter.type === 'price' || filter.type === 'number') {
      return rawProp;
    }
    const normRawProp = rawProp.toLowerCase().replace(/[^a-z0-9]/g, '');
    const normRawName = rawName.toLowerCase().replace(/[^a-z0-9]/g, '');
    if (normRawProp === 'startdate' || normRawProp === 'enddate' || normRawProp === 'daterange' || normRawName === 'daterange') {
      return rawProp;
    }

    // Never alter properties for Sales Target Report
    if ((this.name || '').toLowerCase().includes('sales target') || (this.url || this.router.url || '').toLowerCase().includes('salestarget')) {
      return rawProp;
    }

    // 1. If property already has _cust suffix (case-insensitive), return as-is
    if (/_cust$/i.test(rawProp)) {
      return rawProp;
    }

    const col = this.findMatchingColumn(filter);

    // 2. If matched column property already ends with _cust
    if (col && col.property && /_cust$/i.test(col.property)) {
      return col.property;
    }

    // 3. If property starts with customValuesIs (standard grid prefix for custom attributes)
    if (/^customValuesIs/i.test(rawProp)) {
      const base = (col?.propertyName || col?.attributeCode || rawName || rawProp.replace(/^customValuesIs/i, '')).trim();
      const sanitized = base.replace(/\s+/g, '_').replace(/[()]/g, '_');
      return `${sanitized}_cust`;
    }

    // 4. If matched column property starts with customValuesIs
    if (col && col.property && /^customValuesIs/i.test(col.property)) {
      const base = (col.propertyName || col.attributeCode || rawName || col.property.replace(/^customValuesIs/i, '')).trim();
      const sanitized = base.replace(/\s+/g, '_').replace(/[()]/g, '_');
      return `${sanitized}_cust`;
    }

    // 5. Explicit custom value flag on column
    if (col && (col as any).customValue === true) {
      const base = ((col as any).propertyName || (col as any).attributeCode || rawName || rawProp).trim();
      const sanitized = base.replace(/\s+/g, '_').replace(/[()]/g, '_');
      return `${sanitized}_cust`;
    }

    // 6. DB / Table aliases with dots (e.g. a.status, b.quantity, c.price, FSI.item_name) are normal SQL fields
    if (rawProp.includes('.')) {
      return rawProp;
    }

    // 7. Check Lead/CRM context
    const isLeadContext = (this.name || '').toLowerCase() === 'lead' ||
      (this.url || this.router.url || '').toLowerCase().includes('/lead') ||
      (this.url || this.router.url || '').toLowerCase().includes('/contact');

    if (isLeadContext) {
      // Product & Category custom EAV attributes
      if (this.isProductFilter(filter)) {
        return 'Product_cust';
      }
      if (this.isCategoryFilter(filter)) {
        return 'Category_cust';
      }

      const normProp = rawProp.toLowerCase().replace(/[^a-z0-9]/g, '');
      const normName = rawName.toLowerCase().replace(/[^a-z0-9]/g, '');

      // Known mapper mappings
      if (normProp === 'country' || normName === 'country') return 'Country_cust';
      if (normProp === 'city' || normName === 'city') return 'City_cust';
      if (normProp === 'state' || normName === 'state') return 'State_cust';
      if (normProp === 'crno' || normName === 'crno') return 'Cr_No_cust';
      if (normProp === 'crname' || normName === 'crname') return 'CrName_cust';
      if (normProp === 'college' || normName === 'college') return 'collegeName';
      if (normProp === 'campaignname' || normProp === 'adgroupname') return 'adGroupName_configurableProduct';

      // Normal LeadEntity properties - keep as normal variable (do NOT append _cust)
      const NORMAL_LEAD_PROPERTIES = new Set([
        'entityid', 'leadid', 'incrementid',
        'name',
        'phonenumber', 'phone', 'secondaryphoneno',
        'email', 'emailvalid',
        'statusid', 'statusname', 'leadstatus',
        'sourceid', 'sourcename', 'leadsource',
        'ownerid', 'owneridname', 'owneremail', 'ownername', 'owner',
        'createddate', 'updateddate', 'creationdate', 'modificationdate',
        'startdate', 'enddate', 'daterange', 'fromdate', 'todate',
        'notes', 'lastactivitynotes',
        'score',
        'activitycountonlead', 'activitycount',
        'totalcallduration', 'callduration', 'calldurations',
        'lifecyclestage',
        'isclosedwon',
        'opendealamount', 'wondealamount', 'opendealamountcount', 'wondealamountcount',
        'firstresponsetime', 'approvedstatus', 'ismetalead',
        'timezone',
        'collegename',
        'company', 'companyid',
        'tagname', 'tagnames', 'tags', 'tagid', 'tagids',
        'adgroupname', 'adgroupnameconfigurableproduct', 'campaignname',
        'tenantid', 'attributesetid', 'attributesetname', 'followupdatetime'
      ]);

      if (NORMAL_LEAD_PROPERTIES.has(normProp) || NORMAL_LEAD_PROPERTIES.has(normName)) {
        return rawProp;
      }

      // If it is NOT a normal lead property, it is a custom attribute (cust): append _cust!
      const baseName = (col?.attributeCode || (col as any)?.propertyName || rawName || rawProp).trim();
      const sanitized = baseName.replace(/\s+/g, '_').replace(/[()]/g, '_');
      return /_cust$/i.test(sanitized) ? sanitized : `${sanitized}_cust`;
    }

    return rawProp;
  }

  getCategoryOptionValue(filter: any, opt: any): any {
    if (!opt) return '';
    const prop = (filter?.property || '').toLowerCase();
    if (prop === 'categorynames' || prop === 'category_names' || prop === 'categoryname') {
      return opt.name ?? opt.categoryName ?? opt.id ?? opt.entityId ?? opt.categoryId ?? opt.value;
    }
    return opt.id ?? opt.entityId ?? opt.categoryId ?? opt.name ?? opt.categoryName ?? opt.value;
  }

  getProductOptionValue(filter: any, opt: any): any {
    if (!opt) return '';
    const prop = (filter?.property || '').toLowerCase();
    if (prop === 'productname' || prop === 'productnames' || prop === 'product_name' || prop === 'h.name') {
      return opt.name ?? opt.id ?? opt.entityId ?? opt.productId ?? opt.value;
    }
    return opt.id ?? opt.entityId ?? opt.productId ?? opt.name ?? opt.value;
  }

  getSelectedCategoryId(): any {
    if (!Array.isArray(this.filterSelectObj)) return null;
    const catFilterIdx = this.filterSelectObj.findIndex(f => this.isCategoryFilter(f));
    if (catFilterIdx > -1) {
      const catFilter = this.filterSelectObj[catFilterIdx];
      const val = this[catFilter.position] ?? this.selectedValues[catFilterIdx] ?? catFilter.modelValue;
      if (val) {
        if (Array.isArray(val)) {
          return val.map(v => this.getCategoryIdFromValue(v)).filter(v => !!v).join(' OR ');
        } else if (typeof val === 'string' && val.includes(',')) {
          return val.split(',').map(v => this.getCategoryIdFromValue(v.trim())).filter(v => !!v).join(' OR ');
        }
        return this.getCategoryIdFromValue(val);
      }
    }
    return null;
  }

  getCategoryIdFromValue(catVal: any): any {
    if (catVal == null || catVal === '' || catVal === 'null' || catVal === undefined || catVal === 'ALL') {
      return null;
    }
    const catStr = ('' + catVal).trim();
    if (/^\d+$/.test(catStr)) {
      return catStr;
    }
    if (this.categoryList?.length) {
      const match = this.categoryList.find((c: any) =>
        (c.name || c.categoryName || '').trim().toLowerCase() === catStr.toLowerCase() ||
        ('' + (c.id ?? c.entityId ?? c.categoryId ?? '')).toLowerCase() === catStr.toLowerCase()
      );
      if (match) {
        return match.id ?? match.entityId ?? match.categoryId;
      }
    }
    return null;
  }

  ensureCategoryAndProductTypes() {
    if (!Array.isArray(this.filterSelectObj)) return;
    this.filterSelectObj.forEach((f: any) => {
      if (this.isCategoryFilter(f)) {
        if (!f.type || f.type === 'text' || f.type === 'varchar' || f.type === 'string') {
          f.type = 'select';
        }
        f.options = this.categoryTypeList;
        f._originalOptions = [...this.categoryTypeList];
        f._filteredOptions = [...this.categoryTypeList];
      } else if (this.isProductFilter(f)) {
        if (!f.type || f.type === 'text' || f.type === 'varchar' || f.type === 'string') {
          f.type = 'select';
        }
        const source = (this.masterProductList && this.masterProductList.length > 0) ? this.masterProductList : (this.productList || []);
        f.options = source;
        f._originalOptions = [...source];
        f._filteredOptions = [...source];
      }
    });
  }

  getCategoryList() {
    if (this._categoryLoaded) return;
    this._categoryLoaded = true;
    this.categoriesService.getAllCategories(0, 1000, 'id,desc')
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          const cats = res['content'] || res || [];
          this.categoryList = cats;
          this.categoryTypeList = cats;
          this.filteredCategoryTypeList = cats;
          this.masterCategoryList = cats;

          let indexForProduct = this.filterSelectObj.findIndex(x => this.isProductFilter(x));
          if (indexForProduct > -1) {
            this.fetchProducts();
          }

          this.ensureCategoryAndProductTypes();
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
          this._categoryLoaded = false;
        }
      );
  }

  CategoryYFilter() {
    this.categoryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.categoryFilter();
      });
  }

  protected categoryFilter() {
    if (!this.categoryTypeList) return;
    const search = (this.categoryFilterControl.value || '').toString().toLowerCase().trim();
    if (!search) {
      this.filteredCategoryTypeList = this.categoryTypeList.slice();
    } else {
      this.filteredCategoryTypeList = this.categoryTypeList.filter(
        (c: any) => ((c['name'] || c['categoryName']) || '').toLowerCase().indexOf(search) > -1
      );
    }
    this.cdr.markForCheck();
  }

  fetchProducts(searchTxt?: string) {
    const search = (searchTxt || '').trim();
    const catId = this.getSelectedCategoryId();

    let catFilter = '';
    if (catId) {
      if (catId.includes(' OR ')) {
        const parts = catId.split(' OR ').map(id => `categoryId_txt:*${id}* OR categoryId:${id}`);
        catFilter = `(${parts.join(' OR ')})`;
      } else {
        catFilter = `categoryId_txt:*${catId}* OR categoryId:${catId}`;
      }
    }

    let searchTerm = '';
    if (search && catFilter) {
      searchTerm = `(name:*${search}* OR code:*${search}*) AND (${catFilter})`;
    } else if (search) {
      searchTerm = `name:*${search}* OR code:*${search}*`;
    } else if (catFilter) {
      searchTerm = catFilter;
    }

    const pageSize = search ? 100 : 1000;
    this.productService.getProductByType(0, pageSize, 'id,desc', searchTerm)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          const prods = res['content'] || res || [];
          if (!search) {
            this.masterProductList = prods;
            this.productList = prods;
            this.productTypeList = prods;
            this.filteredProductList = [...prods];
          } else {
            if (Array.isArray(prods) && prods.length > 0) {
              const existingIds = new Set((this.masterProductList || []).map((p: any) => String(p.id ?? p.entityId ?? p.productId ?? p.name)));
              for (const p of prods) {
                const key = String(p.id ?? p.entityId ?? p.productId ?? p.name);
                if (!existingIds.has(key)) {
                  this.masterProductList.push(p);
                  existingIds.add(key);
                }
              }
              this.productList = [...this.masterProductList];
              this.productTypeList = this.productList;
            }
          }
          this.ensureCategoryAndProductTypes();
          this.cdr.markForCheck();
          this.reapplySearchControls();
        },
        error => {
          this._productLoaded = false;
        }
      );
  }

  getProductList(searchTxt?: string) {
    if (this._productLoaded && !searchTxt) return;
    this._productLoaded = true;
    this.fetchProducts(searchTxt);
  }

  ProductYFilter() {
    this.productFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        const search = (this.productFilterControl.value || '').trim();
        const source = (this.masterProductList && this.masterProductList.length > 0) ? this.masterProductList : (this.productList || []);
        if (!search) {
          this.filteredProductList = [...source];
        } else {
          const q = search.toLowerCase();
          this.filteredProductList = source.filter(item => {
            const name = (item.name || '').toLowerCase();
            const code = (item.code || '').toLowerCase();
            return name.includes(q) || code.includes(q);
          });
          this.fetchProducts(search);
        }
        this.cdr.markForCheck();
      });
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }


  trackByValue(index: number, item: any): any {
    if (!item) return index;
    const keys = ['value', 'viewValue', 'statusName', 'sourceName', 'Status', 'email', 'activityType', 'name', 'trackerName', 'id'];
    for (const k of keys) {
      const v = item[k];
      if (v !== undefined && v !== null) return v;
    }
    try {
      return JSON.stringify(item);
    } catch (e) {
      return index;
    }
  }

  /**
   * Comparison function used by `mat-select` to match selected values
   * with option objects even when option arrays are replaced.
   */
  compareOption = (o1: any, o2: any): boolean => {
    if (o1 === o2) return true;
    if (o1 == null || o2 == null) return false;

    const extract = (o: any) => {
      if (o == null) return o;
      if (typeof o !== 'object') return o;
      return o.value ?? o.statusName ?? o.sourceName ?? o.Status ?? o.email ?? o.activityType ?? o.name ?? o.trackerName ?? o.id ?? o.viewValue ?? JSON.stringify(o);
    };

    try {
      if (String(extract(o1)) === String(extract(o2))) return true;
    } catch (e) {
      return false;
    }

    if (this.categoryList && this.categoryList.length > 0) {
      const match1 = this.categoryList.find((c: any) =>
        String(c.id ?? c.entityId ?? c.categoryId ?? '') === String(o1) ||
        String(c.name ?? c.categoryName ?? '').trim().toLowerCase() === String(o1).trim().toLowerCase()
      );
      const match2 = this.categoryList.find((c: any) =>
        String(c.id ?? c.entityId ?? c.categoryId ?? '') === String(o2) ||
        String(c.name ?? c.categoryName ?? '').trim().toLowerCase() === String(o2).trim().toLowerCase()
      );
      if (match1 && match2 && (match1 === match2 || (match1.id != null && match1.id === match2.id))) {
        return true;
      }
    }

    const prods = (this.masterProductList && this.masterProductList.length > 0) ? this.masterProductList : this.productList;
    if (prods && prods.length > 0) {
      const match1 = prods.find((p: any) =>
        String(p.id ?? p.entityId ?? p.productId ?? '') === String(o1) ||
        String(p.name ?? '').trim().toLowerCase() === String(o1).trim().toLowerCase()
      );
      const match2 = prods.find((p: any) =>
        String(p.id ?? p.entityId ?? p.productId ?? '') === String(o2) ||
        String(p.name ?? '').trim().toLowerCase() === String(o2).trim().toLowerCase()
      );
      if (match1 && match2 && (match1 === match2 || (match1.id != null && match1.id === match2.id))) {
        return true;
      }
    }

    return false;
  }

  /**
   * Extract a primitive identifier from an option value (object or primitive).
   */
  extractOptionValue(o: any): any {
    if (o === null || o === undefined) return o;
    if (typeof o !== 'object') return o;
    const keys = ['value', 'Status', 'statusName', 'sourceName', 'email', 'activityType', 'name', 'trackerName', 'id', 'viewValue'];
    for (const k of keys) {
      if (o[k] !== undefined && o[k] !== null) return o[k];
    }
    try { return JSON.stringify(o); } catch (e) { return o; }
  }

  /**
   * Re-apply current search values for all filters.
   * Useful to run after async lists load so existing search text is honored.
   */
  reapplySearchControls(): void {
    if (!Array.isArray(this.filterSelectObj)) return;
    this.filterSearchControls = this.filterSearchControls || [];

    this.filterSelectObj.forEach((filter: any, idx: number) => {
      const control = this.filterSearchControls[idx];
      const q = (control && control.value) ? control.value.toString().trim().toLowerCase() : '';
      const match = (item: any, keys: string[]) => {
        if (!item) return false;
        for (const k of keys) {
          const v = item[k];
          if (v && v.toString().toLowerCase().includes(q)) return true;
        }
        return false;
      };

      if (!q) {
        if (filter.property === 'tagName') this.filteredtagsTypeList = this.tagsTypeList ? [...this.tagsTypeList] : [];
        else if ((filter.property || '').toString().toLowerCase().includes('source')) this.filteredLeadSourceTypeList = this.LeadSourceTypeList ? [...this.LeadSourceTypeList] : [];
        else if (filter.property === 'statusName' || (filter.name || '').toString().toLowerCase().includes('status name') || (filter.name || '').toString().toLowerCase().includes('life stage') || (filter.name || '').toString().toLowerCase().includes('lead status')) this.filtereddropdownTypeList = this.dropdownTypeList ? [...this.dropdownTypeList] : [];
        else if ((filter.property === 'a.status') || ((filter.name || '').toString().toLowerCase() === 'status')) {
          if (this.taskStatusTypeList) this.filteredTaskStatusTypeList = [...this.taskStatusTypeList];
          if (this.UserCallStatusTypeList) this.filteredUserCallStatusTypeList = [...this.UserCallStatusTypeList];
        }
        else if (((filter.property || '').toString().toLowerCase().includes('stage')) || ((filter.name || '').toString().toLowerCase().includes('stage'))) this.filteredlDealStatusTypeList = this.dealStatusTypeList ? [...this.dealStatusTypeList] : [];
        else if (((filter.property || '').toString().toLowerCase().includes('owner')) || ((filter.property || '').toString().toLowerCase().includes('user_name')) || ((filter.property || '').toString().toLowerCase().includes('user_id')) || ((filter.property || '').toString().toLowerCase().includes('created')) || ((filter.name || '').toString().toLowerCase().includes('owner')) || ((filter.name || '').toString().toLowerCase().includes('created by')) || ((filter.name || '').toString().toLowerCase().includes('user name'))) this.filtereduserTypeList = this.userTypeList ? [...this.userTypeList] : [];
        else if ((filter.name || '').toString().toLowerCase().includes('type of service')) this.filteredPayemntTypeList = this.paymentTypeList ? [...this.paymentTypeList] : [];
        else if ((filter.name || '').toString().toLowerCase().includes('activity')) this.filteredActivityTypeList = this.LeadActivityTypeList ? [...this.LeadActivityTypeList] : [];
        else if (((filter.property || '').toString().toLowerCase().includes('industry'))) this.filteredindustryTypeList = this.industryTypeList ? [...this.industryTypeList] : [];
        else if (((filter.property || '').toString().toLowerCase().includes('business'))) this.filteredBusinessTypeList = this.BusinessTypeList ? [...this.BusinessTypeList] : [];
        else if (((filter.property || '').toString().toLowerCase().includes('supplier')) || ((filter.name || '').toString().toLowerCase().includes('suppliers'))) this.filteredsupplierTypeList = this.supplierTypeList ? [...this.supplierTypeList] : [];
        else if (((filter.property || '').toString().toLowerCase().includes('warehouse')) || ((filter.name || '').toString().toLowerCase().includes('location')) || ((filter.name || '').toString().toLowerCase().includes('warehouse'))) this.filteredWarehouseTypeList = this.warehouseTypeList ? [...this.warehouseTypeList] : [];
        else if (((filter.property || '').toString().toLowerCase().includes('tracker')) || ((filter.name || '').toString().toLowerCase().includes('tracker'))) this.filteredTrackerTypeList = this.trackerTypeList ? [...this.trackerTypeList] : [];
        else if ((filter.name || '').toString().toLowerCase().includes('priority')) this.filteredPriorityTypeList = this.priorityTypeList ? [...this.priorityTypeList] : [];
        else if (this.isCategoryFilter(filter)) this.filteredCategoryTypeList = this.categoryTypeList ? [...this.categoryTypeList] : [];
        else if (this.isProductFilter(filter)) {
          const source = (this.masterProductList && this.masterProductList.length > 0) ? this.masterProductList : (this.productList || []);
          this.filteredProductList = [...source];
        }
        // initialize inline options filtered view if options provided
        if (filter.options) {
          // preserve a baseline copy for restore after searches
          filter._originalOptions = JSON.parse(JSON.stringify(filter.options));
          filter._filteredOptions = [...filter.options];
        }
        return;
      }

      if (filter.property === 'tagName') this.filteredtagsTypeList = (this.tagsTypeList || []).filter(item => match(item, ['statusName', 'status', 'name', 'viewValue', 'value']));
      else if ((filter.property || '').toString().toLowerCase().includes('source')) this.filteredLeadSourceTypeList = (this.LeadSourceTypeList || []).filter(item => match(item, ['sourceName', 'name', 'viewValue', 'value']));
      else if (filter.property === 'statusName' || (filter.name || '').toString().toLowerCase().includes('status name') || (filter.name || '').toString().toLowerCase().includes('life stage') || (filter.name || '').toString().toLowerCase().includes('lead status')) this.filtereddropdownTypeList = (this.dropdownTypeList || []).filter(item => match(item, ['statusName', 'status', 'name', 'viewValue', 'value']));
      else if ((filter.property === 'a.status') || ((filter.name || '').toString().toLowerCase() === 'status')) {
        if (this.taskStatusTypeList && this.taskStatusTypeList.length) this.filteredTaskStatusTypeList = (this.taskStatusTypeList || []).filter(item => match(item, ['statusName', 'status', 'name', 'viewValue', 'value']));
        if (this.UserCallStatusTypeList && this.UserCallStatusTypeList.length) this.filteredUserCallStatusTypeList = (this.UserCallStatusTypeList || []).filter(item => match(item, ['Status', 'status', 'name', 'viewValue', 'value']));
        if (!(this.taskStatusTypeList && this.taskStatusTypeList.length) && !(this.UserCallStatusTypeList && this.UserCallStatusTypeList.length) && filter.options) filter._filteredOptions = (filter.options || []).filter(o => (o.viewValue || o.value || '').toString().toLowerCase().includes(q));
      }
      else if (((filter.property || '').toString().toLowerCase().includes('stage')) || ((filter.name || '').toString().toLowerCase().includes('stage'))) this.filteredlDealStatusTypeList = (this.dealStatusTypeList || []).filter(item => match(item, ['statusName', 'status', 'name', 'viewValue', 'value']));
      else if (((filter.property || '').toString().toLowerCase().includes('owner')) || ((filter.property || '').toString().toLowerCase().includes('user_name')) || ((filter.property || '').toString().toLowerCase().includes('user_id')) || ((filter.property || '').toString().toLowerCase().includes('created')) || ((filter.name || '').toString().toLowerCase().includes('owner')) || ((filter.name || '').toString().toLowerCase().includes('created by')) || ((filter.name || '').toString().toLowerCase().includes('user name'))) this.filtereduserTypeList = (this.userTypeList || []).filter(item => match(item, ['email', 'name', 'fullName', 'userName', 'user_name', 'u.user_name', 'a.user_name', 'viewValue', 'value']));
      else if ((filter.name || '').toString().toLowerCase().includes('type of service')) this.filteredPayemntTypeList = (this.paymentTypeList || []).filter(item => match(item, ['name', 'displayName', 'viewValue', 'value']));
      else if ((filter.name || '').toString().toLowerCase().includes('activity')) this.filteredActivityTypeList = (this.LeadActivityTypeList || []).filter(item => match(item, ['activityType', 'name', 'viewValue', 'value']));
      else if (((filter.property || '').toString().toLowerCase().includes('industry'))) this.filteredindustryTypeList = (this.industryTypeList || []).filter(item => match(item, ['statusName', 'name', 'viewValue', 'value']));
      else if (((filter.property || '').toString().toLowerCase().includes('business'))) this.filteredBusinessTypeList = (this.BusinessTypeList || []).filter(item => match(item, ['statusName', 'name', 'viewValue', 'value']));
      else if (((filter.property || '').toString().toLowerCase().includes('supplier')) || ((filter.name || '').toString().toLowerCase().includes('suppliers'))) this.filteredsupplierTypeList = (this.supplierTypeList || []).filter(item => match(item, ['name', 'displayName', 'viewValue', 'value']));
      else if (((filter.property || '').toString().toLowerCase().includes('warehouse')) || ((filter.name || '').toString().toLowerCase().includes('location')) || ((filter.name || '').toString().toLowerCase().includes('warehouse'))) this.filteredWarehouseTypeList = (this.warehouseTypeList || []).filter(item => match(item, ['name', 'displayName', 'viewValue', 'value']));
      else if (((filter.property || '').toString().toLowerCase().includes('tracker')) || ((filter.name || '').toString().toLowerCase().includes('tracker'))) this.filteredTrackerTypeList = (this.trackerTypeList || []).filter(item => match(item, ['name', 'trackerName', 'viewValue', 'value']));
      else if ((filter.name || '').toString().toLowerCase().includes('priority')) this.filteredPriorityTypeList = (this.priorityTypeList || []).filter(item => match(item, ['statusName', 'name', 'viewValue', 'value']));
      else if (this.isCategoryFilter(filter)) this.filteredCategoryTypeList = (this.categoryTypeList || []).filter(item => match(item, ['name', 'categoryName', 'id', 'categoryId', 'viewValue', 'value']));
      else if (this.isProductFilter(filter)) {
        const source = (this.masterProductList && this.masterProductList.length > 0) ? this.masterProductList : (this.productList || []);
        this.filteredProductList = source.filter(item => match(item, ['name', 'code', 'id', 'productId', 'viewValue', 'value']));
      }
      // Always update inline options filtered view, regardless of which branch matched above
      if (filter.options) {
        if (!q) {
          filter._filteredOptions = filter.options ? [...filter.options] : [];
        } else {
          filter._filteredOptions = (filter.options || []).filter(o => (o.viewValue || o.value || '').toString().toLowerCase().includes(q));
        }
      }
    });
    this.cdr.markForCheck();
  }

  /**
   * Map a filter descriptor to an existing search FormControl.
   * Falls back to `typeYFilterControl` when a specific control isn't available.
   */
  getFilterControl(filter: any): UntypedFormControl {
    if (!filter) return this.typeYFilterControl;
    const prop = (filter.property || '').toString().toLowerCase();
    const name = (filter.name || '').toString().toLowerCase();

    if (prop.indexOf('tag') > -1 || name.indexOf('tag') > -1) return this.tagsFilterControl;
    if (name.indexOf('type of service') > -1 || prop.indexOf('service') > -1) return this.paymentFilterControl;
    if (prop.indexOf('source') > -1 || name.indexOf('source') > -1) return this.typeYFilterControl;
    if (prop.indexOf('stage') > -1 || name.indexOf('deal stage') > -1 || name.indexOf('stage') > -1) return this.dealStatusFilterControl;
    if (prop.indexOf('owner') > -1 || name.indexOf('owner') > -1 || name.indexOf('created by') > -1) return this.typeYFilterControl;
    if (prop.indexOf('supplier') > -1 || name.indexOf('suppliers') > -1) return this.supplierFilterControl;
    if (prop.indexOf('warehouse') > -1 || name.indexOf('location') > -1) return this.warehouseFilterControl;
    if (prop.indexOf('industry') > -1 || name.indexOf('industry') > -1) return this.industryFilterControl;
    if (prop.indexOf('business') > -1 || name.indexOf('business') > -1) return this.BusinessFilterControl;
    if (name.indexOf('activity') > -1 || prop.indexOf('activity') > -1) return this.typeYFilterControl;

    // default
    return this.typeYFilterControl;
  }

  isIntegerFilter(filter: any): boolean {
    if (!filter) return false;
    const name = (filter.name || '').toLowerCase().trim();
    const prop = (filter.property || '').toLowerCase().trim();

    if (name.includes('name') || prop.includes('name')) {
      return false;
    }

    return (
      name === 'user number' ||
      name === 'client number' ||
      name === 'employee number' ||
      name === 'phone no' ||
      name === 'phone number' ||
      name === 'customer phone no' ||
      name === 'mobile' ||
      name === 'mobile no' ||
      name === 'mobile number' ||
      name === 'contact no' ||
      name === 'contact number' ||
      name.includes('phone') ||
      prop.includes('phone') ||
      prop.includes('employee_number') ||
      prop.includes('from_number') ||
      prop.includes('telephone') ||
      prop.includes('contact_no') ||
      prop.includes('contact_number') ||
      prop.includes('contactnumber') ||
      prop.includes('contactno')
    );
  }

  isNumericFilter(filter: any): boolean {
    if (!filter) return false;
    const type = (filter.type || '').toLowerCase().trim();
    if (type === 'price' || type === 'number' || type === 'numeric' || type === 'decimal' || type === 'id') {
      return true;
    }
    const name = (filter.name || '').toLowerCase().trim();
    const prop = (filter.property || filter.attributeCode || '').toLowerCase().trim();

    if (name.includes('name') || prop.includes('name')) {
      return false;
    }

    return (
      name.includes('amount') ||
      name.includes('deal value') ||
      name.includes('probability') ||
      name.includes('paid') ||
      name.includes('balance') ||
      name.includes('price') ||
      name.includes('budget') ||
      name.includes('phone') ||
      name.includes('mobile') ||
      name.includes('contact no') ||
      name.includes('contact number') ||
      name.includes('total') ||
      name.includes('subtotal') ||
      name.includes('discount') ||
      name.includes('tax') ||
      name.includes('rate') ||
      prop.includes('amount') ||
      prop.includes('dealvalue') ||
      prop.includes('probability') ||
      prop.includes('paid') ||
      prop.includes('balance') ||
      prop.includes('price') ||
      prop.includes('budget') ||
      prop.includes('total') ||
      prop.includes('subtotal') ||
      prop.includes('discount') ||
      prop.includes('tax') ||
      prop.includes('rate') ||
      prop.includes('phone') ||
      prop.includes('mobile') ||
      prop.includes('contact_no') ||
      prop.includes('contact_number') ||
      prop.includes('contactno') ||
      prop.includes('contactnumber')
    );
  }

  sanitizeFilterInput(filter: any, event: any, index?: number) {
    const target = event.target as HTMLInputElement;
    const value = target?.value ?? '';
    // const name = (filter?.name || '').toLowerCase();
    // const prop = (filter?.property || filter?.attributeCode || '').toLowerCase();
    let sanitized = '';
    if (this.isIntegerFilter(filter) || filter?.type === 'id') {
      sanitized = value.replace(/[^0-9]/g, '');
    } else {
      sanitized = value.replace(/[^0-9.]/g, '');
      const parts = sanitized.split('.');
      if (parts.length > 2) {
        sanitized = parts[0] + '.' + parts.slice(1).join('');
      }
    }
    if (target) {
      target.value = sanitized;
    }
    if (filter) {
      filter.modelValue = sanitized;
    }
    if (index !== undefined && this.filterColumnText) {
      this.filterColumnText(event, index, sanitized);
    }
  }

  restrictNumbers(event: any, filter: any) {
    if (!filter) return true;

    if (this.isIntegerFilter(filter)) {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    }

    if (this.isNumericFilter(filter)) {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode <= 31) {
        return true;
      }
      if (charCode === 46 || event.key === '.') {
        const target = event.target as HTMLInputElement;
        const currentVal = target ? String(target.value || '') : String(filter.modelValue || '');
        const selectedText = (target && target.selectionStart !== null && target.selectionEnd !== null)
          ? currentVal.substring(target.selectionStart, target.selectionEnd)
          : '';
        if (currentVal.includes('.') && !selectedText.includes('.')) {
          event.preventDefault();
          return false;
        }
        return true;
      }
      if (charCode >= 48 && charCode <= 57) {
        return true;
      }
      event.preventDefault();
      return false;
    }

    return true;
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  convertTo12Hour(time: string): string {
    if (!time) {
      return '';
    }
    const t = time.toUpperCase();
    if (t.includes('AM') || t.includes('PM')) {
      return time;
    }
    const [hours, minutes] = time.split(':');
    if (!minutes) return time;
    let h = parseInt(hours, 10);
    const m = minutes.substring(0, 2);
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12;
    h = h ? h : 12;
    return `${h}:${m} ${ampm}`;
  }
}

